import AppDispatcher from "./AppDispatcher";
import { EventEmitter } from "events";
import { isMobile } from "react-device-detect";
import BetQueue from "../clientApp/BetQueue";


let _betslip = {};
let _betReceipt = {};
let _betConfirm = {};
let _oddsLadder = null;
const _polarities = ["back", "lay"];
let _ordersRequested = [];
let _multipleBetsRequested = [];
const _POLARITY = {
    "BACK": "b",
    "LAY": "l"
};
class BetslipStore extends EventEmitter {

    constructor() {
        super();
        this.dispatchToken = AppDispatcher.register(this.dispatcherCallback.bind(this));
        this.setMaxListeners(20);
        this.resources = {};
        this.processBets = this._processBets.bind(this);
        this.processMultiplesBets = this._processMultiplesBets.bind(this);
        this.processBetConfirm = this._processBetConfirm.bind(this);
        this.processFreeBetsEntitlements = this._processFreeBetsEntitlements.bind(this);
        this.calculateOutcome = this._calculateOutcome.bind(this);
        this.calculateOutcomeUnMatched = this._calculateOutcomeUnMatched.bind(this);
        this.calculateOutcomeIfPlaced = this._calculateOutcomeIfPlaced.bind(this);
        this.calculateOutcomeIfUnPlaced = this._calculateOutcomeIfUnPlaced.bind(this);
        this.calculateOverround = this._calculateOverround.bind(this);
        this.calculateAverageOdds = this._calculateAverageOdds.bind(this);
        this.calculateMaxLiability = this.calculateMaxLiability.bind(this);
        this.validateMultipleSelectionsAndBets = this._validateMultipleSelectionsAndBets.bind(this);
        this.clearBetslip = this._clearBetslip.bind(this);
        this.clearBetreceipt = this._clearBetreceipt.bind(this);
        this.resetMultiples = this._resetMultiples.bind(this);
        this.initMultiples = this._initMultiples.bind(this);
        this.defaultsCombination = this._defaultsCombination.bind(this);
        this.setBack2WinLay2LoseStake = this._setBack2WinLay2LoseStake.bind(this);
        this.getCombinationForComponent = this._getCombinationForComponent.bind(this);
        this.getCombinationDisplayNames = this._getCombinationDisplayNames.bind(this);
        this.getCSymbol = this.getCSymbol.bind(this);
        this.isEnabledForEW = this.isEnabledForEW.bind(this);
        this.clearBetslip();
        this.americaniseOdds = this.americaniseOdds.bind(this);
        this.validateMultipleBetsResponse = this.validateMultipleBetsResponse.bind(this);
        this.updateBetslipPriceFormat = this.updateBetslipPriceFormat.bind(this);
        this.processCurrentBets = this.processCurrentBets.bind(this);
        this.processCurrentBetsPLaced = this.processCurrentBetsPLaced.bind(this);
        this.multiplesCounterOffer = this.multiplesCounterOffer.bind(this);
        this.setVisibleVirtualMarketIds = this.setVisibleVirtualMarketIds.bind(this);
        this.hasNewMultipleSBCalls = false;
        this.canBackSP = false;
        this.canLaySP = false;
        this.priceFormat = 1;
        this.priceFormats = {
            "decimal": 1,
            "fractional": 2,
            "american": 3
        };
        this.freeBetsInfo = {
            "forAnyBetType": false,
            "oldestEntitlementForBetTypes": {
                "exFreeBet": null,
                "FOFreeBet": null,
                "multiplesFreeBet": null
            }
        };
        this.displayBackToWin = false;
        this.displayLayToLose = false;
        this.displayOverround = true;
        this.displayExpiryTime = false;
        this.displayAverageOdds = false;
        this.delayFactor = 0;
        this.maximumLiability = 0;
        this.activeSelectionId;
        this.activePolarityId;
        this.visibleVirtualMarketIds = [];
        this.cSymbol = com.globalbettingexchange.base.getCurrencySymbol(GBEglobal.currency, true);
    }

    emitChange(eventName) {
        this.emit(eventName);
    }

    getCSymbol() {
        return this.cSymbol;
    }

    isEnabledForEW(market) {
        const EW_MarketTypes = [19, 20, 21];
        const marketType = market.marketType || market.type;
        if (GBEglobal.settings.betslipConfiguration
            && GBEglobal.settings.betslipConfiguration.enableEachWay) {
            return EW_MarketTypes.includes(marketType);
        }
        return false;
    }

    getFreeBetInfo() {
        return this.freeBetsInfo;
    }

    getBandedDisplayPrice(params) {
        //inputPrice, inputPriceFormat, displayPriceFormat, polarity
        if (params.inputPriceFormat === params.displayPriceFormat) {
            return params.inputPrice;
        }
        let decimalPrice = params.inputPrice;
        if (params.inputPriceFormat === 2) { //it was not decimal, but fraction
            decimalPrice = (decimalPrice) + 1;
        }
        if (params.inputPriceFormat === 3) { //it was not decimal, but american odds
            if (decimalPrice < 0) {
                decimalPrice = 1 - (100 / decimalPrice);
            } else {
                decimalPrice = 1 + (decimalPrice / 100);
            }
        }

        let priceFromOddsLadder = params.oddsLadder.getFromDecimal(decimalPrice);
        if (priceFromOddsLadder && priceFromOddsLadder.representation) {
            return priceFromOddsLadder.representation;
        } else {
            priceFromOddsLadder = params.oddsLadder.band(decimalPrice, params.polarityId === 1 ? -1 : 1);
            if (priceFromOddsLadder && priceFromOddsLadder.representation) {
                return priceFromOddsLadder.representation;
            }
        }
        return "";
    }

    setDefaults(params) {
        this.resources = params.resources;
    }

    updateOddsLadder(oddsLadder) {
        let priceFormatChanged = false;
        _oddsLadder = oddsLadder;
        this.hasNewMultipleSBCalls = (GBEglobal.settings.multiplesConfiguration && (GBEglobal.settings.multiplesConfiguration.version === 2 || GBEglobal.settings.multiplesConfiguration.version === undefined)) ? true : false;
        if (this.priceFormat !== +GBEglobal.priceFormat) {
            this.priceFormat = +GBEglobal.priceFormat || 1;
            priceFormatChanged = true;
            this.updateBetslipPriceFormat();
        }
        return priceFormatChanged;
    }

    updatePreferences(params) {
        //defaultCancelKeepTake
        const userContext = params.userContext;
        const freeBetsEntitlements = params.freeBetsEntitlements;
        let defaultCancelKeepTake = 0;
        if (GBEglobal.preferences && +GBEglobal.preferences.defaultCancelKeepTake > -1) {
            defaultCancelKeepTake = +GBEglobal.preferences.defaultCancelKeepTake;
        }
        _betslip.singles.CKT = defaultCancelKeepTake;
        this.canBackSP = (userContext && userContext.canBackSP);
        this.canLaySP = (userContext && userContext.canLaySP);

        if (typeof GBEglobal.preferences.displayBackToWin !== "undefined") {
            this.displayBackToWin = GBEglobal.preferences.displayBackToWin;
        }
        if (typeof GBEglobal.preferences.displayLayToLose !== "undefined") {
            this.displayLayToLose = GBEglobal.preferences.displayLayToLose;
        }
        if (typeof GBEglobal.preferences.displayOverRound !== "undefined") {
            this.displayOverround = GBEglobal.preferences.displayOverRound;
        }
        if (typeof GBEglobal.preferences.displayExpiryTimePrefs !== "undefined") {
            this.displayExpiryTime = GBEglobal.preferences.displayExpiryTimePrefs;
        }
        if (typeof GBEglobal.preferences.displayAverageOdds !== "undefined") {
            this.displayAverageOdds = GBEglobal.preferences.displayAverageOdds;
        }
        if (typeof GBEglobal.preferences.maximumLiability !== "undefined") {
            this.maximumLiability = parseFloat(GBEglobal.preferences.maximumLiability);
        }
        this.cSymbol = com.globalbettingexchange.base.getCurrencySymbol(GBEglobal.currency, true);

        if (freeBetsEntitlements) {
            this.processFreeBetsEntitlements(freeBetsEntitlements);
        }
        this.hasNewMultipleSBCalls = (GBEglobal.settings.multiplesConfiguration && (GBEglobal.settings.multiplesConfiguration.version === 2 || GBEglobal.settings.multiplesConfiguration.version === undefined)) ? true : false;
        if (userContext && typeof userContext.priceFormat !== "undefined") {
            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                inputUUID: null,
                activeSelectionId: null,
                activePolarityId: null,
                autoFocusStake: false
            });
            this.processMultiplesBets({
                inputBets: _betslip,
                inputUUID: null,
                changedIndex: -1,
                changedLegs: []
            });
        }
    }

    silentlyUpdateFreeBetsEntitlements(freeBetsEntitlements) {
        if (freeBetsEntitlements) {
            this.processFreeBetsEntitlements(freeBetsEntitlements);
        }
    }

    getOddsLadder() {
        return _oddsLadder;
    }

    getPriceFormat() {
        return this.priceFormat;
    }

    toggleBetslip() {
        _betslip.collapsed = !_betslip.collapsed;
    }

    expandBetslip() {
        if (_betslip.collapsed) {
            _betslip.collapsed = false;
            return true;
        }
        return false;
    }

    americaniseOdds(price, priceFormat) {
        if (+priceFormat === 3) {

            return ("" + price).indexOf("-") === 0 ? price : "+" + price;
        } else {
            return price;
        }
    }

    changedSportbookBetslip() {
        return true;
    }

    setSportsbookPrices(sportsbookPrices) {
        _betslip.singles = {
            "back": {
                "events": []
            },
            "lay": {
                "events": []
            }
        };
        sportsbookPrices.forEach(function (sportsbookPrice) {
            let event = null;
            _betslip.singles.back.events.forEach(function (item) {
                if (item.eventClassifierId === sportsbookPrice.eventClassifier.eventClassifierId) {
                    event = item;
                    return false;
                }
            });
            if (!event) {
                event = {
                    "eventClassifierId": sportsbookPrice.eventClassifier.eventClassifierId,
                    "eventClassifierName": sportsbookPrice.eventClassifier.eventClassifierName,
                    "eventClassifier": sportsbookPrice.eventClassifier,
                    "bets": []
                };
                _betslip.singles.back.events.push(event);
            }
            const newBet = {
                eventClassifierId: sportsbookPrice.eventClassifier.eventClassifierId * 1,
                marketId: sportsbookPrice.market.marketId,
                selectionId: sportsbookPrice.selection,
                polarityId: 1,
                stake: "",
                odds: {
                    displayOdds: sportsbookPrice.price.backReferencePrice,
                    decimalOdds: sportsbookPrice.price.backReferencePrice
                },
                selection: sportsbookPrice.selection,
                market: sportsbookPrice.market,
                marketStatus: sportsbookPrice.market.marketStatus || sportsbookPrice.market.marketStatusId || sportsbookPrice.market.status,
                price: sportsbookPrice.price
            };

            event.bets.push(newBet);
        });
    }

    selectPrices(newlySelectedPrices) {
        let action; // = "ADD"; //"UPDATE", "REMOVE"
        let polarity;
        let polarityId;
        let eventClassifier;
        let market;
        let gecMarket;
        let selection;
        let price;
        let events;
        let event;
        let newBet;
        let insertIndex;
        let addedCount = 0;
        let deletedCount = 0;
        let stake;
        let eventClassifierIdAncestryChain = "";
        let takeOnlyExchange = false;
        const betslipStore = this;
        if (GBEglobal.settings.genericConfiguration
            && GBEglobal.settings.genericConfiguration.takeOnlyExchange
            && GBEglobal.settings.genericConfiguration.takeOnlyExchange.enabled) {
            takeOnlyExchange = true;
        }
        betslipStore.hasNewMultipleSBCalls = (GBEglobal.settings.multiplesConfiguration && (GBEglobal.settings.multiplesConfiguration.version === 2 || GBEglobal.settings.multiplesConfiguration.version === undefined)) ? true : false;
        //is it ADD, UPDATE or REMOVE selection price.?
        //is it a new selection, is it another price (index) of same selection?, if its same selection and price then remve i from betslip
        const getTopLevelEvent = function (ev) {
            var parent = ev.getParent();
            eventClassifierIdAncestryChain = ev.eventClassifierId + "~" + eventClassifierIdAncestryChain;
            if (!parent) {
                return ev;
            } else {
                return getTopLevelEvent(parent);
            }
        };
        let selectionsId = "";
        newlySelectedPrices.forEach(function (newlySelectedPrice) {

            action = "ADD"; //"UPDATE", "REMOVE"
            if (!newlySelectedPrice.priceIndex) { //if this is not send from TopX its assumed as Back
                newlySelectedPrice.priceIndex = ["b", "0"];
            }
            polarity = newlySelectedPrice.priceIndex[0] === _POLARITY.LAY ? "lay" : "back";
            polarityId = newlySelectedPrice.priceIndex[0] === _POLARITY.LAY ? 2 : 1;
            eventClassifier = newlySelectedPrice.eventClassifier;
            market = newlySelectedPrice.market;
            gecMarket = newlySelectedPrice.gecMarket;
            selection = newlySelectedPrice.selection;
            price = newlySelectedPrice.price;
            eventClassifierIdAncestryChain = "";
            if (newlySelectedPrice.eventClassifierIdAncestryChain) {
                eventClassifierIdAncestryChain = newlySelectedPrice.eventClassifierIdAncestryChain;
            } else {
                getTopLevelEvent(eventClassifier);
            }

            _polarities.forEach(function (polarity) {
                _betslip.singles[polarity].events.forEach(function (event) {
                    event.bets.forEach(function (bet) {
                        if (selection.selectionId === bet.selectionId
                            && polarityId === bet.polarityId
                            && newlySelectedPrice.priceIndex[1] === bet.priceIndex) {
                            action = "REMOVE";
                            return false;
                        } else if (selection.selectionId === bet.selectionId
                            && polarityId === bet.polarityId) {
                            action = "UPDATE";
                        }
                    });
                });
            });

            //now add to betslip
            //if its under new event then add new event group
            events = _betslip.singles[polarity].events;
            event = null;
            stake = "";
            if (takeOnlyExchange) {
                if (+price.backReferencePrice.stake) {
                    //stake = GBEUtils.formatDecimal(price.backReferencePrice.stake, 0, "", false);
                }
            } else {
                if (+GBEglobal.preferences.defaultStakeOption === 1 || (isMobile && GBEglobal.settings.eventCardConfiguration && GBEglobal.settings.eventCardConfiguration.inlineMobileBets && price.fromInlineBet)) {
                    if (+price.backReferencePrice.stake) {
                        stake = GBEUtils.formatDecimal(price.backReferencePrice.stake, 0, "", false);
                    }
                }
                if (+GBEglobal.preferences.defaultStakeOption === 2 || typeof GBEglobal.preferences.defaultStakeOption === "undefined") {
                    if (+GBEglobal.preferences.defaultStakeOptionValue && !price.fromInlineBet) {
                        stake = GBEUtils.formatDecimal(GBEglobal.preferences.defaultStakeOptionValue, 2, "", false);
                    }
                }
            }
            events.forEach(function (item) {
                if (+item.eventClassifierId === +eventClassifier.eventClassifierId) {
                    event = item;
                    return false;
                }
            });

            if (!event) {
                event = {
                    "eventClassifierId": eventClassifier.eventClassifierId,
                    "eventClassifierName": eventClassifier.eventClassifierName,
                    "eventClassifier": eventClassifier,
                    "bets": []
                };
                _betslip.singles[polarity].events.push(event);
            }
            /*
             * when new selections are added, identify if they are new or existing selections.
             * if existing the clear stake.
             */
            if (action === "ADD") {
                addedCount++;
            }

            if (action === "ADD" || action === "UPDATE") {
                const displayPrice = price.backReferencePrice.displayPrice ? price.backReferencePrice.displayPrice : price.backReferencePrice;
                const band = _oddsLadder.getFromRepresentation(GBEglobal.priceFormat === 1 ? (displayPrice * 1) : displayPrice);
                const odds = {
                    "displayOdds": "",
                    "decimalOdds": "",
                    "selectedOdds": ""
                };
                if (band) {
                    odds.displayOdds = band.representation;
                    odds.decimalOdds = band.price;
                    odds.selectedOdds = band.representation;
                }

                //this is the skeleton of basic Bet object which is used across Exchange Betslip
                //this will hold information/flags related to the Bet
                newBet = {
                    "polarityId": (polarity === "back") ? 1 : 2,
                    "priceIndex": newlySelectedPrice.priceIndex[1],
                    "odds": odds,
                    "stake": stake,
                    "outcome": 0,
                    "isEnabledForEachWayBetting": betslipStore.isEnabledForEW(market),
                    "ew": { total: 0, wins: 0, placed: 0, unplaced: 0 },
                    "eventClassifierId": eventClassifier.eventClassifierId * 1,
                    "eventClassifierIdAncestryChain": eventClassifierIdAncestryChain,
                    "marketId": market.marketId,
                    "withdrawalSequenceNumber": market.withdrawalSequenceNumber,
                    "isCurrentlyInRunning": market.isCurrentlyInRunning,
                    "canBeInRunning": market.willBeInRunning ? market.willBeInRunning : market.canBeInRunning,
                    "selectionResetCount": selection.selectionResetCount,
                    "displayOrder": selection.displayOrder * 1,
                    "marketName": market.name,
                    "selectionName": selection.name,
                    "selectionId": selection.selectionId,
                    "market": market,
                    "gecMarket": gecMarket,
                    "marketStatus": +market.status,
                    "selection": selection,
                    "orderFillType": 1,
                    "delayFactor": +market.delayFactor || 0,
                    "inputOddsUUID": GBEUtils.createUUID(),
                    "inputStakeUUID": GBEUtils.createUUID(),
                    "priceFluctuated": 0,
                    "userUnCheckedMultiple": false,
                    "startTime": market.startTime,
                    "oddsReadOnly": false
                };

                BetQueue.enqueue({
                    selectionId: selection.selectionId,
                    marketId: selection.marketId,
                    selectionName: selection.name,
                    isBack: (polarity === "back"),
                    price: odds.decimalOdds,
                    stake: stake
                });


                selectionsId += selection.selectionId + "_";

                if (newlySelectedPrice.isVirtualWidgetMarket) {
                    newBet.oddsReadOnly = true;
                    newBet.orderFillType = 2;
                } else {
                    newBet.orderFillType = GBEglobal.preferences && GBEglobal.preferences.orderFillType ? parseInt(GBEglobal.preferences.orderFillType, 10) : newBet.orderFillType;
                }

                if (newBet.isEnabledForEachWayBetting
                    && (typeof GBEglobal.preferences.displayEachwayHelp === "undefined" || GBEglobal.preferences.displayEachwayHelp)) {
                    newBet.displayEachWayDetails = true;
                }

                betslipStore.activeSelectionId = newBet.selectionId;
                betslipStore.activePolarityId = newBet.polarityId;

                if (newlySelectedPrice.abc) {
                    betslipStore.activeSelectionId = newlySelectedPrices[0].selection.selectionId;
                    betslipStore.activePolarityId = newlySelectedPrices[0].priceIndex[0] === _POLARITY.LAY ? 2 : 1;
                }
                insertIndex = event.bets.length;

                event.bets.forEach(function (bet, index) {
                    if (bet.displayOrder > newBet.displayOrder) {
                        insertIndex = index;
                        return false;
                    }
                });
                if (action === "UPDATE") { //remove it before adding updated bet
                    event.bets.forEach(function (bet, index) {
                        if (selection.selectionId === bet.selectionId) {
                            event.bets.splice(index, 1);
                            insertIndex -= 1;
                            return false;
                        }
                    });
                }
                event.bets.splice(insertIndex, 0, newBet);

            } else {
                event.bets.forEach(function (bet, index) {
                    if (selection.selectionId === bet.selectionId) {
                        event.bets.splice(index, 1);
                        deletedCount += 1;
                        return false;
                    }
                });
                if (!event.bets.length) {
                    events.forEach(function (item, index) {
                        if (+item.eventClassifierId === +eventClassifier.eventClassifierId) {
                            events.splice(index, 1);
                            return false;
                        }
                    });
                } else {
                    event.bets[0].activeBet = true;
                    betslipStore.activeSelectionId = event.bets[0].selectionId;
                    betslipStore.activePolarityId = event.bets[0].polarityId;
                }
            }
        });
        _betslip.mode = "betslip";
        _betslip.activeTab = _betslip.activeTab === "open-bets" ? "singles" : _betslip.activeTab;

        GBEglobal.logClientEntry({
            componentName: "ex_betslip",
            subcomponentName: "SelectionsAdded",
            systemInteractionType: 1,
            logEntry: selectionsId + newlySelectedPrices.length
        });

        this.processBets({
            inputBets: _betslip,
            selectionsAddedOrDeleted: (addedCount > 0 || deletedCount > 0),
            activeSelectionId: betslipStore.activeSelectionId,
            activePolarityId: betslipStore.activePolarityId
        });
        //group it based on polarity, event,
        //_betslip.bets.push(price);
    }

    setActiveBetCursor(params) {
        const betslipStore = this;
        betslipStore.activePolarityId = (params.type === "back") ? 1 : 2;
        betslipStore.activeSelectionId = params.selection.selectionId;
        this.processBets({
            inputBets: _betslip,
            selectionsAddedOrDeleted: false,
            activeSelectionId: betslipStore.activeSelectionId,
            activePolarityId: betslipStore.activePolarityId
        });
    }

    //getBetslipState- this returns betslip state. ONLY to be used by betslip component.

    getBetslipState() {
        return _betslip;
    }

    //getBets - this method can be used by outside components
    //this returns a flat list of bets
    //this is NOT used for displaying Betslip, but this is for other components like EventCard to use it for calculating P&L

    getBets() {
        var betslipBets = [];

        _polarities.forEach(function (polarity) {
            const events = _betslip.singles[polarity].events;

            events.forEach(function (event) {
                const bets = event.bets;
                bets.forEach(function (bet) {
                    betslipBets.push({
                        eventClassifierId: bet.eventClassifierId,
                        marketId: bet.marketId,
                        selectionId: bet.selectionId,
                        polarityId: bet.polarityId,
                        stake: bet.stake,
                        displayOdds: bet.odds.displayOdds,
                        decimalOdds: bet.odds.decimalOdds
                    });
                });
            });
        });
        return betslipBets;
    }

    getSelectionBet(selectionId, polarityId) {
        var betToReturn;

        _polarities.forEach(function (polarity) {
            const events = _betslip.singles[polarity].events;

            events.forEach(function (event) {
                const bets = event.bets;
                bets.forEach(function (bet) {
                    if (bet.selectionId === selectionId && bet.polarityId === polarityId) {
                        betToReturn = bet;
                        return false;
                    }
                });
            });
        });
        return betToReturn;
    }

    getBetReceipt() {
        return _betReceipt;
    }

    getBetConfirm() {
        _betConfirm = {};
        this.processBetConfirm();
        return _betConfirm;
    }

    getDelayFactor() {
        return this.delayFactor;
    }

    getOrdersRequested() {
        return _ordersRequested;
    }

    getMultipleBetRequested() {
        return _multipleBetsRequested;
    }

    getBetslipActiveTab() {
        return _betslip.activeTab;
    }

    isFreeBetsChecked() {
        if (_betslip.activeTab === "singles") {
            return _betslip.singles.freeBetsCheckBox.checked;
        } else if (_betslip.activeTab === "multiples") {
            return _betslip.multiples.freeBetsCheckBox.checked;
        }
    }

    removeBet(params) {
        const events = _betslip.singles[params.polarityId === 1 ? "back" : "lay"].events;
        let event;
        _betslip.singles.error = null;
        this.activeSelectionId = null;
        this.activePolarityId = null;
        if (params.orderId !== undefined && _betslip.activeTab === "open-bets") {
            event = _betslip.currentBets[params.betType][params.polarityId === 1 ? "back" : "lay"];
            _betslip.currentBets.betChange = true;
            event.bets.map((currentBet) => {
                if (currentBet.orderId === params.orderId) {
                    currentBet.cancel = !currentBet.cancel;
                    currentBet.inValid = currentBet.cancel;
                }
                return currentBet;
            });
            return false;
        } else {
            events.forEach(function (item) {
                if (params.eventClassifierId === item.eventClassifierId) {
                    event = item;
                    return false;
                }
            });
            event.bets.forEach(function (item, index) {
                if (params.selectionId === item.selectionId) {
                    event.bets.splice(index, 1);
                    return false;
                }
            });

            if (event.bets.length > 0) {
                event.bets[0].activeBet = true;
                this.activeSelectionId = event.bets[0].selectionId;
                this.activePolarityId = event.bets[0].polarityId;
            }

            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                activeSelectionId: this.activeSelectionId,
                activePolarityId: this.activePolarityId
            });
            this.initMultiples(_betslip);
            GBEglobal.logClientEntry({
                componentName: "ex_betslip",
                subcomponentName: "SelectionsRemoved",
                systemInteractionType: 1,
                logEntry: 1
            });
        }
        return true;
    }

    changeStake(params) {
        const bet = params.bet;
        const betSlipStore = this;
        const stake = params.stake;
        const events = _betslip.singles[bet.polarityId === 1 ? "back" : "lay"].events;
        let activeSelectionId = null;
        let activePolarityId = null;
        let event;
        _betslip.singles.error = null;
        if (bet.orderId !== undefined && _betslip.activeTab === "open-bets") {
            const betType = bet.matchedStake > 0 ? "matchedBets" : "unMatchedBets";
            event = _betslip.currentBets[betType][bet.polarityId === 1 ? "back" : "lay"];
            _betslip.currentBets.betChange = true;
            event.bets.map((currentBet) => {
                if (currentBet.orderId === bet.orderId) {
                    currentBet.stake = stake;
                    _betslip.activeInputUUID = currentBet.inputStakeUUID;
                    currentBet.stakeChanged = parseFloat(stake) !== parseFloat(currentBet.isEnabledForEachWayBetting ? currentBet.originalStake / 2 : currentBet.originalStake);
                    const outcome = betSlipStore.calculateOutcomeUnMatched(currentBet, currentBet.odds.decimalOdds, currentBet.stake);
                    currentBet.outcome = GBEUtils.formatDecimal(outcome, 2, this.getCSymbol());
                }
                return currentBet;
            });
        } else {
            events.forEach(function (item) {
                if (bet.eventClassifierId === item.eventClassifierId) {
                    event = item;
                    return false;
                }
            });
            event.bets.forEach(function (item) {
                if (bet.selectionId === item.selectionId) {
                    bet.stake = stake;
                    activeSelectionId = item.selectionId;
                    activePolarityId = item.polarityId;
                    return false;
                }
            });
            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                inputUUID: params.inputUUID,
                activeSelectionId: activeSelectionId,
                autoFocusStake: true,
                activePolarityId: activePolarityId
            });
        }
    }
    //called when odds is changed in Betslip.

    changeOdds(params) {
        const bet = params.bet;
        const displayOdds = params.odds;
        const events = _betslip.singles[bet.polarityId === 1 ? "back" : "lay"].events;
        let activeSelectionId = null;
        let activePolarityId = null;
        const betslipStore = this;

        let event;
        let band = _oddsLadder.getFromRepresentation(displayOdds);
        if (!band) {
            band = {
                representation: displayOdds,
                price: displayOdds
            };
        }
        if (bet.orderId !== undefined && _betslip.activeTab === "open-bets") {
            const betType = bet.matchedStake > 0 ? "matchedBets" : "unMatchedBets";
            event = _betslip.currentBets[betType][bet.polarityId === 1 ? "back" : "lay"];
            _betslip.currentBets.betChange = true;
            event.bets.map((currentBet) => {
                if (currentBet.orderId === bet.orderId) {
                    // if (!(params.odds > 0 && !isNaN(params.odds)) && GBEglobal.priceFormat !== 2) {
                    //     params.odds = 1.01;
                    //     band = _oddsLadder.getFromRepresentation(params.odds);
                    // }
                    if (!band) {
                        band = _oddsLadder.band(params.odds);
                    }
                    currentBet.odds.displayOdds = band.representation;
                    currentBet.odds.decimalOdds = band.price;
                    currentBet.odds.selectedOdds = band.representation;
                    _betslip.activeInputUUID = currentBet.inputOddsUUID;
                    currentBet.oddsChanged = parseFloat(band.price) !== parseFloat(currentBet.originalOdds.decimalOdds);
                    const outcome = betslipStore.calculateOutcomeUnMatched(currentBet, currentBet.odds.decimalOdds, currentBet.stake);
                    currentBet.outcome = GBEUtils.formatDecimal(outcome, 2, this.getCSymbol());
                }
                return currentBet;
            });
        } else {
            _betslip.singles.error = null;
            events.forEach(function (item) {
                if (bet.eventClassifierId === item.eventClassifierId) {
                    event = item;
                    return false;
                }
            });
            event.bets.forEach(function (item) {
                if (bet.selectionId === item.selectionId) {
                    bet.odds.displayOdds = band.representation;
                    bet.odds.decimalOdds = band.price;
                    bet.odds.selectedOdds = band.representation;
                    activeSelectionId = item.selectionId;
                    activePolarityId = item.polarityId;

                    betslipStore.setBack2WinLay2LoseStake(bet);
                    return false;
                }
            });
            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                inputUUID: params.inputUUID,
                activeSelectionId: activeSelectionId,
                activePolarityId: activePolarityId,
                autoFocusOdds: true
            });
        }
    }

    checkFreeBets() {
        if (_betslip.activeTab === "singles") {
            _betslip.singles.freeBetsCheckBox.checked = !_betslip.singles.freeBetsCheckBox.checked;
            if (!_betslip.singles.freeBetsCheckBox.checked) {
                _betslip.singles.error = null;
            }
        } else if (_betslip.activeTab === "multiples") {
            _betslip.multiples.freeBetsCheckBox.checked = !_betslip.multiples.freeBetsCheckBox.checked;
        }
    }
    //called when odds is changed in Betslip by clicking Up/Down arrows / stepper

    stepOdds(params) {
        const betslipStore = this;
        const bet = params.bet;
        let newOdds;
        let decimalOdds;
        const events = _betslip.singles[bet.polarityId === 1 ? "back" : "lay"].events;
        let activeSelectionId = null;
        let activePolarityId = null;
        let event;
        _betslip.singles.error = null;
        if (bet.orderId !== undefined && _betslip.activeTab === "open-bets") {
            const betType = bet.matchedStake > 0 ? "matchedBets" : "unMatchedBets";
            event = _betslip.currentBets[betType][bet.polarityId === 1 ? "back" : "lay"];
            _betslip.currentBets.betChange = true;
            event.bets.map((currentBet) => {
                if (currentBet.orderId === bet.orderId) {
                    decimalOdds = bet.odds.decimalOdds;
                    if (!decimalOdds) {
                        newOdds = _oddsLadder.band(1.01);
                    } else {
                        newOdds = _oddsLadder.step(decimalOdds, params.direction);
                    }
                    _betslip.activeInputUUID = currentBet.inputOddsUUID;
                    if (newOdds) {
                        currentBet.odds.displayOdds = newOdds.representation;
                        currentBet.odds.decimalOdds = newOdds.price;
                        currentBet.odds.selectedOdds = newOdds.representation;
                        currentBet.oddsChanged = parseFloat(newOdds.price) !== parseFloat(currentBet.originalOdds.decimalOdds);

                        const outcome = betslipStore.calculateOutcomeUnMatched(currentBet, currentBet.odds.decimalOdds, currentBet.stake);
                        currentBet.outcome = GBEUtils.formatDecimal(outcome, 2, this.getCSymbol());
                    }
                }
                return currentBet;
            });
        } else {
            events.forEach(function (item) {
                if (bet.eventClassifierId === item.eventClassifierId) {
                    event = item;
                    return false;
                }
            });
            event.bets.forEach(function (item) {
                if (bet.selectionId === item.selectionId) {
                    decimalOdds = bet.odds.decimalOdds;
                    if (!decimalOdds) {
                        newOdds = _oddsLadder.band(1.01);
                    } else {
                        newOdds = _oddsLadder.step(decimalOdds, params.direction);
                    }

                    if (newOdds) {
                        bet.odds.displayOdds = newOdds.representation;
                        bet.odds.decimalOdds = newOdds.price;
                        bet.odds.selectedOdds = newOdds.representation;
                    }
                    activeSelectionId = item.selectionId;
                    activePolarityId = item.polarityId;

                    betslipStore.setBack2WinLay2LoseStake(bet);
                    return false;
                }
            });
            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                inputUUID: params.inputUUID,
                activeSelectionId: activeSelectionId,
                activePolarityId: activePolarityId,
                autoFocusOdds: true
            });
        }
    }

    _setBack2WinLay2LoseStake(bet) {
        const backToWin = _betslip.singles.backToWin;
        const layToLose = _betslip.singles.layToLose;
        const payOut = _betslip.singles.payOut;
        const decimalOdds = bet.odds.decimalOdds;

        const fraction = 0;  //!eachway
        if (!decimalOdds || +decimalOdds < 1.01) {
            return false;
        }
        if (+bet.polarityId === 1) {
            if (backToWin > 0 && +bet.polarityId === 1) {
                bet.stake = (backToWin / ((decimalOdds - 1) + ((decimalOdds - 1) * fraction))).toFixed(2);
            }
        } else {
            if (layToLose > 0) {
                if (!payOut) {
                    const stakeValueBase = layToLose / ((decimalOdds - 1) + ((decimalOdds - 1) * fraction));
                    let stakeValue = stakeValueBase.toFixed(2);
                    if (stakeValue * (decimalOdds - 1) > layToLose) {
                        stakeValue = Math.floor(stakeValueBase * 100) / 100; /*round down to two decimals*/
                        stakeValue = stakeValue.toFixed(2);
                    }
                    bet.stake = stakeValue;
                } else {
                    if (fraction > 0) {
                        bet.stake = (layToLose / ((decimalOdds * 1) + (((decimalOdds - 1) * fraction) + 1))).toFixed(2);
                    } else {
                        bet.stake = (layToLose / ((decimalOdds) * (1 + fraction))).toFixed(2);
                    }
                }
            }
        }
    }

    //must validate odds expecially when user is directly entering it.
    //consider current price format when validating.
    validateOdds(params) {
        const bet = params.bet;
        const betslipStore = this;
        const cSymbol = this.getCSymbol();
        let displayOdds;
        const polarityId = bet.polarityId;
        const events = _betslip.singles[bet.polarityId === 1 ? "back" : "lay"].events;
        let event;
        const invalidOddsEntered = this.resources.BetSlip.invalidOddsEntered;
        let invalidOddsIndex = 0;
        let message = "";
        let totalStake;
        let outcome;
        _betslip.singles.error = null;
        if (bet.orderId !== undefined && _betslip.activeTab === "open-bets") {
            const betType = bet.matchedStake > 0 ? "matchedBets" : "unMatchedBets";
            event = _betslip.currentBets[betType][bet.polarityId === 1 ? "back" : "lay"];
            _betslip.currentBets.betChange = true;
        } else {
            events.forEach(function (item) {
                if (bet.eventClassifierId === item.eventClassifierId) {
                    event = item;
                    return false;
                }
            });
        }
        event.bets.forEach(function (item) {
            if (bet.selectionId === item.selectionId) {
                bet.error = false;
                displayOdds = bet.odds.displayOdds;
                return false;
            }
        });
        if (displayOdds === "") {
            return true;
        }
        //now validate displayOdds
        if (this.priceFormat === this.priceFormats.decimal) {
            displayOdds = displayOdds * 1;
        }
        let band = _oddsLadder.getFromRepresentation(displayOdds);
        if (!band) {
            if (this.priceFormat === this.priceFormats.decimal) {
                displayOdds = displayOdds * 1;
                if (!isNaN(displayOdds)) {
                    if (displayOdds >= 6 && displayOdds <= 10) {
                        invalidOddsIndex = 1;
                    } else if (displayOdds > 10 && displayOdds <= 20) {
                        invalidOddsIndex = 2;
                    } else if (displayOdds > 20 && displayOdds <= 50) {
                        invalidOddsIndex = 3;
                    } else if (displayOdds > 50 && displayOdds <= 200) {
                        invalidOddsIndex = 4;
                    } else if (displayOdds > 200 && displayOdds <= 1000) {
                        invalidOddsIndex = 5;
                    } else if (displayOdds > 1000) {
                        invalidOddsIndex = 6;
                    }
                }
                displayOdds = parseFloat(displayOdds);
                message = invalidOddsEntered[invalidOddsIndex];
            }

            if (this.priceFormat === this.priceFormats.fractional) {
                if (displayOdds.indexOf("/") > -1) {
                    displayOdds = displayOdds.split("/");
                    displayOdds = (+displayOdds[0] / +displayOdds[1]) + 1.0;
                } else {
                    displayOdds = +displayOdds + 1.0;
                }
                message = invalidOddsEntered[7];
            }
            if (this.priceFormat === this.priceFormats.american) {
                message = invalidOddsEntered[8];
                displayOdds = parseInt(displayOdds);
                if (isNaN(displayOdds)) {
                    displayOdds = 0.0;
                } else if (displayOdds > 0) {
                    displayOdds = (displayOdds + 100.0) / 100.0;
                } else {
                    displayOdds = (1.0 / (-displayOdds / 100.0)) + 1.0;
                }
            }

            if (!(displayOdds > 0 && !isNaN(displayOdds))) {
                displayOdds = 1.01;
                band = _oddsLadder.getFromDecimal(displayOdds);
            } else {
                band = _oddsLadder.step(displayOdds, (polarityId === 1 ? 1 : -1));
            }

            _betslip.singles.error = {
                "message": message
            };
            totalStake = 0;
            if (bet.orderId !== undefined && _betslip.activeTab === "open-bets") {
                event.bets.forEach(function (item) {
                    if (bet.selectionId === item.selectionId && +bet.polarityId === item.polarityId) {
                        _betslip.activeInputUUID = item.inputOddsUUID;
                        if (band) {
                            item.odds.displayOdds = band.representation;
                            item.odds.decimalOdds = band.price;
                            item.odds.selectedOdds = band.representation;
                        }
                    }
                    if (+bet.stake > 0) {
                        totalStake += +bet.stake;
                        outcome = betslipStore.calculateOutcomeUnMatched(bet, bet.odds.decimalOdds, bet.stake);
                        item.outcome = GBEUtils.formatDecimal(outcome, 2, cSymbol);
                    }
                });
            } else {
                _polarities.forEach(function (polarity) {
                    _betslip.singles[polarity].events.forEach(function (event) {
                        event.bets.forEach(function (item) {
                            if (bet.selectionId === item.selectionId
                                && +bet.polarityId === item.polarityId) {
                                _betslip.activeInputUUID = item.inputOddsUUID;
                                if (band) {
                                    bet.odds.displayOdds = band.representation;
                                    bet.odds.decimalOdds = band.price;
                                    bet.odds.selectedOdds = band.representation;
                                }
                                if (bet.odds.decimalOdds && +bet.odds.decimalOdds >= 1.01) {
                                    betslipStore.setBack2WinLay2LoseStake(bet);
                                }
                            }
                            if (+item.stake > 0) {
                                totalStake += +item.stake;
                                outcome = betslipStore.calculateOutcome(item);
                                item.outcome = GBEUtils.formatDecimal(outcome, 2, cSymbol);
                            }
                        });
                    });
                });
                betslipStore.calculateOverround(_betslip);
                _betslip.singles.totals.stake = GBEUtils.formatDecimal(totalStake, 2, cSymbol);
            }
            return false;
        } else {
            return true;
        }
    }

    stepStake(params) {
        const bet = params.bet;
        const betslipStore = this;
        var direction = params.direction;
        let event;
        const minStake = "1.00";
        let newStake = minStake;
        let activeSelectionId = null;
        let activePolarityId;
        if (bet.orderId !== undefined && _betslip.activeTab === "open-bets") {
            const betType = bet.matchedStake > 0 ? "matchedBets" : "unMatchedBets";
            event = _betslip.currentBets[betType][bet.polarityId === 1 ? "back" : "lay"];
            _betslip.currentBets.betChange = true;
            event.bets.map((currentBet) => {
                if (currentBet.orderId === bet.orderId) {
                    if (bet.stake) {
                        newStake = (+bet.stake + direction).toFixed(2);
                    }
                    if (newStake < minStake) {
                        newStake = minStake;
                    }
                    currentBet.stake = newStake;
                    _betslip.activeInputUUID = currentBet.inputStakeUUID;
                    currentBet.stakeChanged = parseFloat(newStake) !== parseFloat(currentBet.originalStake);
                    const outcome = betslipStore.calculateOutcomeUnMatched(currentBet, currentBet.odds.decimalOdds, currentBet.stake);
                    currentBet.outcome = GBEUtils.formatDecimal(outcome, 2, this.getCSymbol());
                }
                return currentBet;
            });
        } else {
            const events = _betslip.singles[bet.polarityId === 1 ? "back" : "lay"].events;
            _betslip.singles.error = null;
            events.forEach(function (item) {
                if (bet.eventClassifierId === item.eventClassifierId) {
                    event = item;
                    return false;
                }
            });
            event.bets.forEach(function (item) {
                if (bet.selectionId === item.selectionId) {
                    if (bet.stake) {
                        newStake = (+bet.stake + direction).toFixed(2);
                    }
                    if (newStake < minStake) {
                        newStake = minStake;
                    }
                    activeSelectionId = bet.selectionId;
                    activePolarityId = bet.polarityId;
                    bet.stake = newStake;
                    return false;
                }
            });
            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                inputUUID: params.inputUUID,
                activeSelectionId: activeSelectionId,
                activePolarityId: activePolarityId,
                autoFocusStake: true
            });
        }
    }

    /*
     * This is called when clicking PlaceBet.
     * This method will do all validations before preparing bets for placing.
     * Only bets with stake will be considered for creating _ordersRequested & _multipleBetsRequested.     *
     * This method will only set _ordersRequested & _multipleBetsRequested, but wont return them.
     * BetslipWrapper will call another method to get _ordersRequested & _multipleBetsRequested which will be used when calling GEC methods.
     */
    placeBets() {
        //1 - continue with placebet. all validations success
        //2 - show bet confirm
        // 3 - validations failed. update view.
        const betslipStore = this;
        let placeBetStatus = 3;
        let isStakeValid = true;

        if (_betslip.activeTab === "open-bets") {
            _betslip.currentBets.betChange = true;
            this.clearBetreceipt();
            _betslip.activeTab = "open-bets";
            _betReceipt.activeTab = "open-bets";
            return 1;
        } else {
            if (GBEglobal.preferences.betReviewPage
                && _betslip.mode === "betconfirm") {
                //_betslip.mode = "betslip";
                return 1;
            }
            betslipStore.delayFactor = 0;
            let validBetsInEvent = [];
            const cSymbol = this.getCSymbol();
            const resources = this.resources;
            const isSinglesTab = _betslip.activeTab === "singles";
            let invalidOdds = false;
            let minStakeValid = true;
            let expiryTimeInvalid = false;
            let freeBetsTotalStakeInvalid = false;
            let freeBetsSelectionsInvalid = false;
            let freeBetsPriceInvalid = false;
            let exFreeBet;
            let multiplesFreeBet;
            let freeBetsInfo;
            let takeOnlyExchange = false;
            if (GBEglobal.settings.genericConfiguration
                && GBEglobal.settings.genericConfiguration.takeOnlyExchange
                && GBEglobal.settings.genericConfiguration.takeOnlyExchange.enabled) {
                takeOnlyExchange = true;
            }
            const minStake = GBEglobal.settings.minimumStake[GBEglobal.currency];

            let activeInputUUID; //this is to focus and highlight input fields when warning
            let multipleTotalStake = 0;
            const minimumTotalStake = GBEglobal.settings.multiplesConfiguration[GBEglobal.currency].MinimumTotalStake;
            const minimumStakePerLine = GBEglobal.settings.multiplesConfiguration[GBEglobal.currency].MinimumStakePerLine;
            let minimumStakePerLineValid = true;
            let freeBetChecked = false;

            //if multiples draftmode - accept & continue
            if (!isSinglesTab && _betslip.draftMode) {
                _betslip.draftMode = false;
                _betslip.multiples.selections.forEach(function (selection) {
                    selection.error = false;
                    selection.priceFluctuated = 0;
                });
                if (this.validateMultipleSelectionsAndBets(_betslip)) {
                    this.resetMultiples(_betslip);
                }
                return 3;
            }
            _ordersRequested = [];
            _multipleBetsRequested = [];
            this.clearBetreceipt();
            _betslip.singles.totals = {
                "stake": 0,
                "outcome": 0
            };
            let maxAllowedStakeMessage = "";
            _betslip.activeInputUUID = null;
            if (isSinglesTab) {
                let expiresAt = "7000-12-31";
                if (_betslip.singles.displayExpiryTime
                    && _betslip.singles.expiryChecked) {
                    expiresAt = _betslip.singles.expiryTime;
                    if (expiresAt === null || GBEUtils.jsDate(expiresAt).getTime() < (new Date().getTime())) {
                        expiryTimeInvalid = true;
                    }
                }
                if (_betslip.singles.freeBetsCheckBox
                    && _betslip.singles.freeBetsCheckBox.checked) {
                    freeBetChecked = true;
                    freeBetsInfo = betslipStore.freeBetsInfo;
                    if (freeBetsInfo && freeBetsInfo.oldestEntitlementForBetTypes && freeBetsInfo.oldestEntitlementForBetTypes.exFreeBet) {
                        exFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.exFreeBet;
                    }
                }
                _polarities.forEach(function (polarity) {
                    _betslip.singles[polarity].events.forEach(function (event) {
                        const eventClassifierFullName = event.eventClassifierName;
                        validBetsInEvent = [];
                        event.bets.forEach(function (bet) {
                            let order;
                            let withdrawRepriceOptionId;
                            let subscribedSelection;
                            if (bet.odds.decimalOdds
                                && bet.stake > 0) {
                                if (+bet.polarityId === 1) {
                                    withdrawRepriceOptionId = GBEglobal.preferences.backRepriceOption;
                                } else {
                                    withdrawRepriceOptionId = GBEglobal.preferences.layRepriceOption;
                                }
                                if (bet.market && bet.market.selections !== undefined && bet.market.selections.length > 0) {
                                    subscribedSelection = bet.market.selections.find(function (selection) {
                                        return selection.selectionId === bet.selection.selectionId;
                                    });
                                }
                                order = {
                                    cancelIfSelectionReset: true,
                                    cancelOnInRunning: true,
                                    eventClassifierFullName: eventClassifierFullName,
                                    eventClassifierId: event.eventClassifierId,
                                    expectedSelectionResetCount: subscribedSelection ? subscribedSelection.selectionResetCount : bet.selectionResetCount,
                                    expectedWithdrawalSequenceNumber: bet.withdrawalSequenceNumber,
                                    expiresAt: expiresAt,
                                    //fillOrKillThreshold: bet.stake,
                                    marketName: bet.marketName,
                                    orderFillType: bet.orderFillType,
                                    polarityId: bet.polarityId,
                                    requestedForSidePrice: bet.odds.decimalOdds,
                                    requestedForSideStake: bet.stake,
                                    subscribedSelection: bet.selection,
                                    withdrawRepriceOptionId: withdrawRepriceOptionId,
                                    isFreeBet: freeBetChecked
                                };
                                if (bet.isEnabledForEachWayBetting) {
                                    //order.fillOrKillThreshold = bet.stake * 2;
                                    order.requestedForSideStake = bet.stake * 2;
                                }

                                if (bet.isCurrentlyInRunning) {
                                    order.cancelOnInRunning = false;
                                    order.cancelIfSelectionReset = true;
                                    order.orderFillType = 1;
                                    if (bet.delayFactor > betslipStore.delayFactor) {
                                        betslipStore.delayFactor = bet.delayFactor;
                                    }
                                } else {
                                    if (_betslip.singles.displayCKT) {
                                        if (_betslip.singles.CKT === 2 && bet.enableXSP) {
                                            order.orderFillType = 5;//SPIfUnmatched
                                        } else {
                                            if (bet.canBeInRunning) {
                                                order.cancelOnInRunning = _betslip.singles.CKT !== 1;
                                                if (_betslip.singles.CKT === 1) { //keep IR
                                                    order.cancelIfSelectionReset = false;
                                                }
                                            }
                                        }
                                    }
                                }
                                if (takeOnlyExchange) {
                                    //FillAndKill(2)
                                    order.orderFillType = 2;
                                }
                                _betslip.singles.totals.stake += bet.isEnabledForEachWayBetting ? bet.stake * 2 : +bet.stake;
                                validBetsInEvent.push(bet);
                                if (bet.stake < minStake) {
                                    minStakeValid = false;
                                    activeInputUUID = bet.inputStakeUUID;
                                } else {
                                    _ordersRequested.push(order);
                                }
                                if (parseFloat(bet.stake) > betslipStore.maximumLiability && betslipStore.maximumLiability > 0 && +bet.polarityId === 1) {
                                    isStakeValid = false;
                                } else if (parseFloat(betslipStore.calculateMaxLiability(bet)) > betslipStore.maximumLiability && betslipStore.maximumLiability > 0 && +bet.polarityId === 2) {
                                    isStakeValid = false;
                                }

                                if (freeBetChecked && exFreeBet) {
                                    if (exFreeBet.eventClassifierId > 1) {
                                        if (bet.eventClassifierIdAncestryChain.indexOf(exFreeBet.eventClassifierId) === -1) {
                                            freeBetsSelectionsInvalid = true;
                                        }
                                    }
                                    if (exFreeBet.marketTypes && exFreeBet.marketTypes.length) {
                                        if (!exFreeBet.marketTypes.includes(bet.market.marketType)) {
                                            freeBetsSelectionsInvalid = true;
                                        }
                                    }
                                    if (exFreeBet.restrictedToInRunning
                                        && !bet.isCurrentlyInRunning) {
                                        freeBetsSelectionsInvalid = true;
                                    }
                                }

                            } else {
                                if (bet.stake > 0 && !bet.odds.decimalOdds) {
                                    invalidOdds = true;
                                    if (!activeInputUUID) {
                                        activeInputUUID = bet.inputOddsUUID;
                                    }
                                }
                            }
                        });
                        if (validBetsInEvent.length) {
                            _betReceipt.singles[polarity].events.push({
                                "eventClassifierId": event.eventClassifier.eventClassifierId,
                                "eventClassifierName": event.eventClassifier.eventClassifierName,
                                "eventClassifier": event.eventClassifier,
                                "bets": validBetsInEvent
                            });
                            _betReceipt.singles.payOut = _betslip.singles.payOut;
                        }
                    });
                });
                if (freeBetChecked
                    && _betslip.singles.totals.stake > 0) {
                    if (exFreeBet) {
                        if (_betslip.singles.totals.stake > exFreeBet.amountRemaining) {
                            freeBetsTotalStakeInvalid = true;
                        }
                    }
                }

                _betslip.singles.totals.stake = GBEUtils.formatDecimal(_betslip.singles.totals.stake, 2, cSymbol, false);
                if (expiryTimeInvalid) {
                    _betslip.singles.error = {
                        message: resources.BetSlip.inValidExpiryTime
                    };
                    _ordersRequested = [];
                    if (activeInputUUID) {
                        _betslip.activeInputUUID = activeInputUUID;
                    }
                    return 3;
                } else if (!minStakeValid) {
                    _betslip.singles.error = {
                        message: String.format(resources.BetSlip.StakeMustBeGreaterThan, GBEUtils.formatDecimal(minStake, 2, cSymbol, false))
                    };
                    _ordersRequested = [];
                    if (activeInputUUID) {
                        _betslip.activeInputUUID = activeInputUUID;
                    }
                    return 3;
                } else if (invalidOdds && !_ordersRequested.length) {
                    _betslip.singles.error = {
                        message: "The odds you have entered are invalid. Please try again"
                    };
                    if (activeInputUUID) {
                        _betslip.activeInputUUID = activeInputUUID;
                    }
                    return 3;
                    //_ordersRequested = [];
                } else if (freeBetsTotalStakeInvalid) {
                    _betslip.singles.error = {
                        message: resources.FreeBetsExceedsTotalStake
                    };
                    if (activeInputUUID) {
                        _betslip.activeInputUUID = activeInputUUID;
                    }
                    return 3;
                    //_ordersRequested = [];
                } else if (freeBetsSelectionsInvalid) {
                    _betslip.singles.error = {
                        message: resources.FreeBetsInValidSelections
                    };
                    if (activeInputUUID) {
                        _betslip.activeInputUUID = activeInputUUID;
                    }
                    return 3;
                    //_ordersRequested = [];
                }

                placeBetStatus = (_ordersRequested.length > 0) ? 1 : 3;
            } else {
                if (GBEglobal.preferences.betReviewPage
                    && _betslip.mode === "betconfirm") {
                    _betslip.mode = "betslip";
                    return 1;
                }
                //const multiplesConfiguration = GBEglobal.settings.multiplesConfiguration;
                //const multiplesMinStake = multiplesConfiguration[GBEglobal.currency];
                //do multipls stake here
                const combinationsForComponent = _betslip.multiples.combinationsForComponent;
                //let multipleTotalStake = 0;
                //let minCheckValidationFailed = false;
                const selections = _betslip.multiples.selections.filter(function (selection) {
                    return selection.checked;
                });
                let multiplesTotalStake = 0;
                _betReceipt.multiples = {};
                _betReceipt.multiples.combinationsForComponent = [];
                _betReceipt.multiples.selections = selections;
                _betReceipt.multiples.totals = _betslip.multiples.totals;
                _betReceipt.activeTab = "multiples";
                if (!this.validateMultipleSelectionsAndBets(_betslip) && !betslipStore.hasNewMultipleSBCalls) {
                    return 3;
                }
                if (_betslip.multiples.freeBetsCheckBox
                    && _betslip.multiples.freeBetsCheckBox.checked) {
                    freeBetChecked = true;
                    freeBetsInfo = betslipStore.freeBetsInfo;
                    if (freeBetsInfo && freeBetsInfo.oldestEntitlementForBetTypes && freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet) {
                        multiplesFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet;
                    }
                    if (multiplesFreeBet) {
                        _betslip.multiples.selections.forEach(function (selection) {
                            if (multiplesFreeBet.eventClassifierId > 1) {
                                if (selection.eventClassifierIdAncestryChain.indexOf(multiplesFreeBet.eventClassifierId) === -1) {
                                    freeBetsSelectionsInvalid = true;
                                }
                            }
                            if (multiplesFreeBet.marketTypes && multiplesFreeBet.marketTypes.length) {
                                if (!multiplesFreeBet.marketTypes.includes(selection.market.marketType)) {
                                    freeBetsSelectionsInvalid = true;
                                }
                            }
                        });
                    }
                }
                const combinationTypes = [];
                let accaGroupName;
                combinationsForComponent.forEach(function (combinationForComponent, index) {
                    const combination = _betslip.multiples.combinations[index];
                    let clientGroupReference;
                    if (combinationForComponent.stake > 0) {
                        if (betslipStore.hasNewMultipleSBCalls) {
                            if (combinationForComponent.accaGroupName) {
                                accaGroupName = combinationForComponent.accaGroupName;
                            }
                        } else {
                            accaGroupName = combination.name.split(" ({0})")[0];
                        }
                        multipleTotalStake += combinationForComponent.stake * combinationForComponent.count;
                        clientGroupReference = GBEUtils.createUUID();
                        combination.clientGroupReference = clientGroupReference;
                        combinationForComponent.clientGroupReference = clientGroupReference;
                        combinationForComponent.count = combination.count;
                        combinationForComponent.isFreeBet = freeBetChecked;
                        combinationForComponent.c_stake = GBEUtils.formatDecimal(combinationForComponent.stake, 2, cSymbol, false);
                        combinationForComponent.c_outcome = GBEUtils.formatDecimal(combinationForComponent.outcome, 2, cSymbol, false);
                        if (combinationForComponent.stake < minimumStakePerLine) {
                            minimumStakePerLineValid = false;
                            activeInputUUID = combinationForComponent.inputStakeUUID;
                        }
                        if (combinationForComponent.stake > combinationForComponent.maxStake && !betslipStore.hasNewMultipleSBCalls) {
                            maxAllowedStakeMessage = String.format(resources.BetSlip.MaxStakeAtPrice, GBEUtils.formatDecimal(combinationForComponent.maxStake, 2, cSymbol, false));
                            combinationForComponent.error = true;
                            activeInputUUID = combinationForComponent.inputStakeUUID;
                            return 3;
                        }
                        if (freeBetChecked && multiplesFreeBet) {
                            if (combinationForComponent.compositeOdds < multiplesFreeBet.minPrice) {
                                freeBetsPriceInvalid = true;
                            }
                        }


                        if (betslipStore.hasNewMultipleSBCalls) {
                            if (combination.legs.length === 1) {
                                combinationTypes.push({
                                    combinationType: combinationForComponent.combinationType[0],
                                    expectedCombinationCount: combinationForComponent.combinationCount[combinationForComponent.combinationType[0]],
                                    requestedUnitStake: {
                                        amount: combinationForComponent.stake,
                                        currency: GBEglobal.currency
                                    }
                                });
                            } else {
                                combination.legs.forEach(function (leg) {
                                    combinationTypes.push({
                                        combinationType: leg,
                                        expectedCombinationCount: combinationForComponent.combinationCount[leg],
                                        requestedUnitStake: {
                                            amount: combinationForComponent.stake,
                                            currency: GBEglobal.currency
                                        }
                                    });
                                });
                            }
                        } else {
                            if (combinationForComponent.legs.length === 1) {
                                //multipleTotalStake += +combinationForComponent.stake;
                                combination.quotations.forEach(function (quotation) {
                                    multiplesTotalStake += +combinationForComponent.stake;
                                    _multipleBetsRequested.push({
                                        "selections": quotation.selections,
                                        "requestedGrossForSideStake": combinationForComponent.stake,
                                        "requestedForSidePrice": quotation.offers[0].offerPrice,
                                        "accaGroupName": accaGroupName,
                                        "clientGroupReference": clientGroupReference
                                    });
                                });
                            } else if (combinationForComponent.legs.length > 1) {
                                combination.legs.forEach(function (leg) {
                                    const currentLegQuotations = _betslip.multiples.legWiseCombinations["leg" + leg].quotations;
                                    currentLegQuotations.forEach(function (currentLegQuotation) {
                                        multiplesTotalStake += +combinationForComponent.stake;
                                        _multipleBetsRequested.push({
                                            "selections": currentLegQuotation.selections,
                                            "requestedGrossForSideStake": combinationForComponent.stake,
                                            "requestedForSidePrice": currentLegQuotation.offers[0].offerPrice,
                                            "accaGroupName": accaGroupName,
                                            "clientGroupReference": combination.clientGroupReference
                                        });
                                    });
                                });
                            }
                        }
                        _betReceipt.multiples.combinationsForComponent.push(combinationForComponent);
                    }
                });

                if (betslipStore.hasNewMultipleSBCalls && combinationTypes.length > 0) {
                    const participants = [];
                    _betslip.multiples.selections.filter((o) => o.checked).forEach(function (sel) {
                        sel.error = false;
                        participants.push({
                            selectionId: sel.selectionId,
                            isBanker: sel.isBanker,
                            requestedPrice: sel.decimalFixedOdds,
                            expectedSelectionResetCount: sel.expectedSelectionResetCount,
                            expectedWithdrawalSequenceNumber: sel.expectedWithdrawalSequenceNumber
                        });
                    });
                    _multipleBetsRequested.push({
                        "participants": participants,
                        "combinationTypes": combinationTypes,
                        "counterOfferId": _betslip.multiples.counterOfferId,
                        "accaGroupName": accaGroupName
                    });
                }

                if (freeBetChecked
                    && multipleTotalStake > 0) {
                    if (multiplesFreeBet) {
                        if (multipleTotalStake > multiplesFreeBet.amountRemaining) {
                            freeBetsTotalStakeInvalid = true;
                        }
                    }
                }

                if (!minimumStakePerLineValid) {
                    _multipleBetsRequested = [];
                    _betslip.multiples.error = {
                        message: String.format(resources.BetSlip.MinStakePerLineAllowed, GBEUtils.formatDecimal(minimumStakePerLine, 2, cSymbol, false))
                    };
                    if (activeInputUUID) {
                        _betslip.activeInputUUID = activeInputUUID;
                    }
                    return 3;
                } else if (maxAllowedStakeMessage !== "") {
                    _multipleBetsRequested = [];
                    _betslip.multiples.error = {
                        message: maxAllowedStakeMessage
                    };
                    if (activeInputUUID) {
                        _betslip.activeInputUUID = activeInputUUID;
                    }
                    return 3;
                } else if (multipleTotalStake < minimumTotalStake) {
                    _multipleBetsRequested = [];
                    _betslip.multiples.error = {
                        message: String.format(resources.BetSlip.MinTotalStakeLineAllowed, GBEUtils.formatDecimal(minimumTotalStake, 2, cSymbol, false))
                    };
                    return 3;
                } else if (freeBetsTotalStakeInvalid) {
                    _multipleBetsRequested = [];
                    _betslip.multiples.error = {
                        message: resources.FreeBetsExceedsTotalStake
                    };
                    return 3;
                } else if (freeBetsPriceInvalid) {
                    _multipleBetsRequested = [];
                    _betslip.multiples.error = {
                        message: resources.FreeBetsExceedsMinPrice
                    };
                    return 3;
                } else if (freeBetsSelectionsInvalid) {
                    _multipleBetsRequested = [];
                    _betslip.multiples.error = {
                        message: resources.FreeBetsInValidSelections
                    };
                    return 3;
                }

                if (parseFloat(multiplesTotalStake) > betslipStore.maximumLiability && betslipStore.maximumLiability > 0) {
                    isStakeValid = false;
                }
                placeBetStatus = (_multipleBetsRequested.length > 0) ? 1 : 3;
            }
        }
        if (!isStakeValid && _betslip.mode === "betslip" && _betslip.confirmedMaxLiability !== undefined && !_betslip.confirmedMaxLiability) {
            return 4;
        }

        _betslip.confirmedMaxLiability = false;
        if (placeBetStatus === 1
            && GBEglobal.preferences.betReviewPage
            && _betslip.mode === "betslip") {
            _betslip.mode = "betconfirm";
            placeBetStatus = 2;
        }

        return placeBetStatus;
    }


    _clearBetreceipt() {
        _betReceipt = {
            "mode": "betreceipt",
            "activeTab": "singles",
            "collapsed": false,
            "singles": {
                "count": 0,
                "back": {
                    "events": []
                },
                "lay": {
                    "events": []
                },
                "totals": {
                    "stake": 0,
                    "outcome": 0
                },
                "freeBetsCheckBox": {
                    "show": false,
                    "disabled": false,
                    "checked": false
                }
            },
            "multiples": {
                "levelsToRequest": [],
                "selections": [],
                "combinations": [],
                "combinationsForComponent": [],
                "totals": {
                    "stake": 0,
                    "outcome": 0
                },
                "freeBetsCheckBox": {
                    "show": false,
                    "disabled": false,
                    "checked": false
                }
            }
        };
        _betReceipt.currentBets = _betslip.currentBets;
    }

    /*
     * this method will set the skeleton of Betslip State which is a reflection of the way in which Bets are Betslip.
     * its grouped under 'singles', 'multiples', 'currentBets'.
     * In 'singles' they are grouped on polarity, ie, back & lay.
     * In 'currentBets' they are grouped as 'matched' and 'unMatched' and with in that  they are grouped on polarity, ie, back & lay.
     * And within polarity they are ordered under events.
     * All selections from same event will be under its own event.
     *
     */

    _clearBetslip() {
        if (_betslip.activeTab !== "open-bets") {
            const cSymbol = this.getCSymbol();
            let CKT = 0;
            if (GBEglobal.preferences && +GBEglobal.preferences.defaultCancelKeepTake > -1) {
                CKT = +GBEglobal.preferences.defaultCancelKeepTake;
            }
            _betslip = {
                "draftMode": false,
                "mode": "betslip",
                "activeTab": "singles",
                "activeInputUUID": null,
                "collapsed": false,
                "confirmedMaxLiability": false,
                "singles": {
                    "expiryChecked": false,
                    "CKT": CKT,
                    "displayCKT": false,
                    "payOut": false,
                    "displayTakeXSP": false,
                    "displayKeep": true,
                    "count": 0,
                    "back": {
                        "events": []
                    },
                    "lay": {
                        "events": []
                    },
                    "totals": {
                        "stake": cSymbol + "0.00",
                        "outcome": 0
                    },
                    "delayFactor": 0,
                    "freeBetsCheckBox": {
                        "show": false,
                        "disabled": false,
                        "checked": false
                    }
                },
                "multiples": {
                    "levelsToRequest": [],
                    "selections": [],
                    "combinations": [],
                    "combinationsForComponent": [],
                    "totals": {
                        "stake": cSymbol + "0.00",
                        "outcome": 0
                    },
                    "freeBetsCheckBox": {
                        "show": false,
                        "disabled": false,
                        "checked": false
                    }
                },
                "currentBets": {
                    "CKT": CKT,
                    "displayCKT": false,
                    "displayTakeXSP": false,
                    "displayKeep": true,
                    "delayFactor": 0,
                    "mode": "betslip",
                    "betChange": false,
                    "count": 0,
                    "unMatchedBets": {
                        "back": {
                            "bets": []
                        },
                        "lay": {
                            "bets": []
                        }
                    },
                    "matchedBets": {
                        "back": {
                            "bets": []
                        },
                        "lay": {
                            "bets": []
                        }
                    },
                    "updatedBets": {
                        "back": {
                            "bets": []
                        },
                        "lay": {
                            "bets": []
                        }
                    }
                }
            };
            /*
            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                activeSelectionId: null
            });

            this.initMultiples(_betslip);
            */
        }
    }

    cancelAllBets() {
        _betslip.currentBets.betChange = true;
        this.activeSelectionId = null;
        this.activePolarityId = null;
        this.clearBetreceipt();
        _betslip.activeTab = "open-bets";
        _betReceipt.activeTab = "open-bets";
    }

    /*
     *When Multiple BetQuotations are available, process them and show in UI.
     * GEC request to get Quotation is made only once for a set of selections, its requested again when new selections is added/removed.
     * a GEC common method is there for processing those quotations.
     */
    setSBMultipleBetQuotations(params) {
        const betslipStore = this;
        const combinationsForComponent = [];
        const multipleSelections = _betslip.multiples.selections;
        _betslip.multiples.levelsToRequest = [];
        _betslip.multiples.requestedSBMultipleBetQuotation = params;
        const finalCombinations = gec.Controller.prototype.getMultiplesSBBaseCombinations({
            combinations: params.combinationTypes,
            totalCombinationCount: params.totalCombinationCount
        });
        function sortCombinations(a, b) {
            if (a.legs.length === 1) {
                if (a.legs[0] < b.legs[0]) {
                    return -1;
                }
            }
            return 0;
        }
        finalCombinations.forEach(function (combination, index) {
            let odds = 0;
            let requiredStake = 0;
            let compositeOddsDisplay;
            const combinationCount = {};
            const combinationLegs = combination.legs;
            combination.legs.forEach(function (leg) {
                const quotedCombination = params.combinationTypes.find((o) => o.combinationType === leg);
                if (quotedCombination) {
                    odds += quotedCombination.potentialReturns.amount;
                    requiredStake += quotedCombination.requiredStake.amount;
                    combinationCount[quotedCombination.combinationType] = quotedCombination.combinationCount;
                }
            });
            const combinationForComponent = betslipStore.getCombinationForComponent(combination, finalCombinations.length - 1, index);
            combinationForComponent.level = 0;
            combinationForComponent.combinationType = combinationLegs;
            combinationForComponent.requiredStake = requiredStake;
            combinationForComponent.combinationCount = combinationCount;
            combinationForComponent.maxStake = 99999999;
            combinationForComponent.compositeOdds = GBEUtils.formatDecimal(odds, 2, "", false);
            compositeOddsDisplay = combinationForComponent.compositeOdds;

            if (betslipStore.priceFormat !== betslipStore.priceFormats.decimal && combinationForComponent.compositeOdds) {
                compositeOddsDisplay = _oddsLadder.band(odds, -1, false, true).representation;
                compositeOddsDisplay = betslipStore.americaniseOdds(compositeOddsDisplay, betslipStore.priceFormat);
            }
            if (!(+combinationForComponent.compositeOdds)) {
                compositeOddsDisplay = "";
            }
            if (combination.hasAccaGroupName) {
                combinationForComponent.accaGroupName = combination.name.split(" ({0})")[0];
            }

            combinationForComponent.compositeOddsDisplay = compositeOddsDisplay;
            combinationsForComponent.push(combinationForComponent);
        });

        _betslip.multiples.selections = multipleSelections;
        _betslip.multiples.displayCombinationsCount = combinationsForComponent.length;
        _betslip.multiples.combinationsForComponent = combinationsForComponent.sort(sortCombinations);
        _betslip.multiples.combinations = combinationsForComponent;
        this.validateMultipleSelectionsAndBets(_betslip);
    }

    setMultipleBetQuotations(params) {
        const checkedMultipleSelections = [];
        const betslipStore = this;
        _betslip.multiples.selections.forEach(function (selection) {
            if (selection.checked) {
                checkedMultipleSelections.push(selection);
            }
        });
        if (params.levelsRequested.length === _betslip.multiples.levelsToRequest.length) {
            _betslip.multiples.levelsToRequest = [];
        }

        const multiBetslip = GBEUtils.processMultipleBetQuotations({
            "quotations": params.response,
            "selections": checkedMultipleSelections,
            "multiBetSlip": {
                "combinations": _betslip.multiples.combinations,
                "legWiseCombinations": {},
                "levelsRequested": params.levelsRequested
            }
        });
        _betslip.multiples.legWiseCombinations = multiBetslip.legWiseCombinations;

        const combinationsForComponent = _betslip.multiples.combinationsForComponent.map(function (combinationsForComponent) {
            var combination;
            var compositeOddsDisplay;
            multiBetslip.combinations.forEach(function (item) {
                if (combinationsForComponent.level > 0) {
                    if (combinationsForComponent.level === item.level) {
                        combination = item;
                        return false;
                    }
                } else {
                    if (combinationsForComponent.count === item.count) {
                        combination = item;
                        return false;
                    }
                }
            });
            combination.compositeOdds = GBEUtils.formatDecimal(combination.compositeOdds, 2, "", false);
            compositeOddsDisplay = combination.compositeOdds;

            combinationsForComponent.state = 2;
            combinationsForComponent.maxStake = combination.maxStake;
            combinationsForComponent.compositeOdds = combination.compositeOdds;

            if (betslipStore.priceFormat !== betslipStore.priceFormats.decimal && combination.compositeOdds) {
                compositeOddsDisplay = _oddsLadder.band(combination.compositeOdds, -1, false, true).representation;
                compositeOddsDisplay = betslipStore.americaniseOdds(compositeOddsDisplay, betslipStore.priceFormat);
            }
            if (!(+combination.compositeOdds)) {
                compositeOddsDisplay = "";
                combinationsForComponent.disable = true;
            }
            if (!(+combination.maxStake > 0)) {
                combinationsForComponent.disable = true;
            }
            combinationsForComponent.compositeOddsDisplay = compositeOddsDisplay;
            return combinationsForComponent;

        });
        _betslip.multiples.combinationsForComponent = combinationsForComponent;
    }

    multiplesCounterOffer(params) {
        const resources = this.resources;
        const cSymbol = this.getCSymbol();
        const counterOfferCombination = _betslip.multiples.combinationsForComponent.find((c) => c.stake > 0);
        const maxStake = params.counterOfferStake.amount;
        const newStake = maxStake.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        counterOfferCombination.stake = newStake;
        if (params.counterOfferId) {
            _betslip.multiples.counterOfferId = params.counterOfferId;
        }

        counterOfferCombination.maxStake = newStake;
        counterOfferCombination.requiredStake = newStake;
        counterOfferCombination.counterOfferReasonText = String.format(resources.BetSlip.MaxAvailableStake, cSymbol, params.counterOfferStake.amount);
        const changedIndex = counterOfferCombination.index;
        const changedLegs = counterOfferCombination.legs;
        counterOfferCombination.error = true;
        const activeInputUUID = counterOfferCombination.inputStakeUUID;
        _betslip.multiples.error = {
            message: counterOfferCombination.counterOfferReasonText
        };
        _betslip.activeTab = "multiples";
        _betslip.mode = "betslip";
        this.processMultiplesBets({
            inputBets: _betslip,
            changedIndex: changedIndex,
            changedLegs: changedLegs,
            inputUUID: activeInputUUID
        });
    }

    changeMultiStake(params) {
        const combinationForComponent = params.combinationForComponent;
        const stake = params.stake;
        const betslipStore = this;
        let changedIndex;
        let changedLegs;

        const combinationsForComponent = _betslip.multiples.combinationsForComponent.filter(function (multipleCombination) {
            if (multipleCombination.index === combinationForComponent.index) {
                multipleCombination.stake = stake;
                changedIndex = combinationForComponent.index;
                changedLegs = combinationForComponent.legs;
            }
            return multipleCombination;
        });
        _betslip.multiples.combinationsForComponent = combinationsForComponent;

        if (betslipStore.hasNewMultipleSBCalls) {
            _betslip.multiples.counterOfferId = null;
        }

        this.processMultiplesBets({
            inputBets: _betslip,
            inputUUID: params.inputUUID,
            changedIndex: changedIndex,
            changedLegs: changedLegs
        });
    }

    stepMultiStake(params) {
        const combinationForComponent = params.combinationForComponent;
        const betslipStore = this;
        let changedIndex;
        let changedLegs;
        const combinationsForComponent = _betslip.multiples.combinationsForComponent.filter(function (multipleCombination) {
            if (multipleCombination.index === combinationForComponent.index) {
                changedIndex = combinationForComponent.index;
                changedLegs = combinationForComponent.legs;
                if (!multipleCombination.stake) {
                    multipleCombination.stake = 1;
                } else {
                    multipleCombination.stake = (+multipleCombination.stake + params.direction).toFixed(2);
                }
                if (!multipleCombination.stake) {
                    multipleCombination.stake = 1;
                }
            }
            return multipleCombination;
        });
        _betslip.multiples.combinationsForComponent = combinationsForComponent;
        if (betslipStore.hasNewMultipleSBCalls) {
            _betslip.multiples.counterOfferId = null;
        }
        this.processMultiplesBets({
            inputBets: _betslip,
            inputUUID: params.inputUUID,
            changedIndex: changedIndex,
            changedLegs: changedLegs
        });
    }

    changeMultiOutcome(params) {
        const combinationForComponent = params.combinationForComponent;
        let changedIndex;
        let changedLegs;
        const combinationsForComponent = _betslip.multiples.combinationsForComponent.filter(function (multipleCombination) {
            if (multipleCombination.index === combinationForComponent.index) {
                if (+params.outcome < 0.19) {
                    multipleCombination.stake = "";
                } else {
                    multipleCombination.stake = GBEUtils.formatDecimal(params.outcome / (multipleCombination.compositeOdds - 1), 2, "", false);
                }
                changedIndex = combinationForComponent.index;
                changedLegs = combinationForComponent.legs;
            }
            return multipleCombination;
        });
        _betslip.multiples.combinationsForComponent = combinationsForComponent;

        this.processMultiplesBets({
            inputBets: _betslip,
            inputUUID: params.inputUUID,
            changedIndex: changedIndex,
            changedLegs: changedLegs
        });
    }

    stepMultiOutcome(params) {
        const combinationForComponent = params.combinationForComponent;

        let changedIndex;
        let changedLegs;
        const combinationsForComponent = _betslip.multiples.combinationsForComponent.filter(function (multipleCombination) {
            if (multipleCombination.index === combinationForComponent.index) {
                let outcome = 1;
                let stake;
                changedLegs = multipleCombination.legs;
                changedIndex = combinationForComponent.index;
                if (+params.outcome < 0.19) {
                    multipleCombination.stake = "";
                } else {
                    multipleCombination.stake = GBEUtils.formatDecimal(params.outcome / (multipleCombination.compositeOdds - 1), 2, "", false);
                }

                if (!multipleCombination.outcome) {
                    multipleCombination.stake = 1;
                } else {
                    outcome = (+multipleCombination.outcome + params.direction).toFixed(2);
                    stake = GBEUtils.formatDecimal(outcome / (multipleCombination.compositeOdds - 1), 2, "", false);
                    if (stake > 0) {
                        multipleCombination.stake = stake;
                    }
                }
                if (!multipleCombination.stake) {
                    multipleCombination.stake = 1;
                }

            }
            return multipleCombination;
        });

        _betslip.multiples.combinationsForComponent = combinationsForComponent;

        this.processMultiplesBets({
            inputBets: _betslip,
            inputUUID: params.inputUUID,
            changedIndex: changedIndex,
            changedLegs: changedLegs
        });
    }

    clickMultipleSelection(params) {
        const initialCheckedSelectionsCount = _betslip.multiples.selections.filter((s) => s.checked).length;
        const checkedSelectionsCount = params.checked ? initialCheckedSelectionsCount + 1 : initialCheckedSelectionsCount - 1;
        let triggerAlert = false;
        _betslip.multiples.selections.forEach(function (selection) {
            if (selection.selectionId === params.selectionId) {
                if (checkedSelectionsCount <= GBEglobal.settings.multiplesConfiguration.MaxMultipleSelectionsAllowed) {
                    selection.checked = params.checked;
                } else {
                    triggerAlert = true;
                }
                //update priceFluctuated in singles.bets, so it will retain when new price added
                _polarities.forEach(function (polarity) {
                    const events = _betslip.singles[polarity].events;
                    events.forEach(function (event) {
                        event.bets.forEach(function (bet) {
                            if (+bet.selectionId === +selection.selectionId && checkedSelectionsCount <= GBEglobal.settings.multiplesConfiguration.MaxMultipleSelectionsAllowed) {
                                bet.userUnCheckedMultiple = !params.checked;
                            }
                        });
                    });
                });
            }
        });
        if (triggerAlert) {
            const warningMessage = String.format(this.resources.multiplebetslip.maxNumberOfSelection, GBEglobal.settings.multiplesConfiguration.MaxMultipleSelectionsAllowed);
            _betslip.multiples.warning = { message: warningMessage };
            setTimeout(() => {
                _betslip.multiples.warning = { message: "" };
                this.emitChange("STORE_CHANGE_BETSLIP");
            }, 5000);
            return false;
        }
        if (this.hasNewMultipleSBCalls) {
            _betslip.multiples.levelsToRequest = [1];
        } else {
            if (this.validateMultipleSelectionsAndBets(_betslip)) {
                this.resetMultiples(_betslip);
            }
        }
    }

    _validateMultipleSelectionsAndBets(inputBets) {
        const betslipStore = this;
        const resources = this.resources;
        const checkedEventIds = {};
        const conflictedEventIds = [];
        let invalidBets = 0;
        let priceChangedCount = 0;
        let errorMessage = null;
        let warningMessage = null;
        const cSymbol = this.getCSymbol();
        if (inputBets.mode === "betreceipt") {
            return false;
        }
        inputBets.multiples.selections.forEach(function (selection) {
            selection.error = false;
        });

        inputBets.multiples.combinationsForComponent.forEach(function (combinationForComponent) {
            combinationForComponent.disable = false;
        });

        //suspended/completed selection
        _polarities.forEach(function (polarity) {
            _betslip.singles[polarity].events.forEach(function (event) {
                event.bets.forEach(function (bet) {

                    inputBets.multiples.selections.forEach(function (selection) {
                        if (selection.selectionId === bet.selectionId) {
                            if (selection.checked) {
                                if (bet.marketStatus !== 2) {
                                    selection.error = true;
                                    invalidBets += 1;
                                } else {
                                    selection.error = false;
                                }
                                if (selection.priceFluctuated === -1
                                    || selection.priceFluctuated === 1) {
                                    priceChangedCount += 1;
                                }
                            }
                        }
                    });
                });
            });
        });
        inputBets.draftMode = false;
        if (!invalidBets && !betslipStore.hasNewMultipleSBCalls) { //check selections under same event.
            inputBets.multiples.selections.forEach(function (selection) {
                selection.error = false;
                if (selection.checked) {
                    if (!checkedEventIds[selection.eventClassifierId]) {
                        checkedEventIds[selection.eventClassifierId] = 1;
                    } else {
                        checkedEventIds[selection.eventClassifierId] += 1;
                    }
                }
            });
            Object.keys(checkedEventIds).forEach(function (eventId) {
                if (checkedEventIds[eventId] > 1) {
                    conflictedEventIds.push(+eventId);
                }
            });

            //selection from same events
            inputBets.multiples.selections.forEach(function (selection) {
                if (selection.checked) {
                    if (conflictedEventIds.includes(selection.eventClassifierId)) {
                        selection.error = true;
                    }
                }
            });
        }

        if (!invalidBets && betslipStore.hasNewMultipleSBCalls && _betslip.multiples.requestedSBMultipleBetQuotation !== undefined && _betslip.multiples.requestedSBMultipleBetQuotation.selections !== undefined) {
            inputBets.multiples.selections.forEach(function (selection) {
                selection.blockedSelectionIds = [];
                selection.error = false;
                selection.message = "";
                if (selection.checked) {
                    const isSelectionBlocked = _betslip.multiples.requestedSBMultipleBetQuotation.selections.find((s) => s.blockedSelectionIds !== undefined && s.blockedSelectionIds.includes(selection.selectionId)) ? true : false;

                    const multipleSelection = _betslip.multiples.requestedSBMultipleBetQuotation.selections.find((o) => o.selectionId === selection.selectionId);
                    selection = { ...selection, ...multipleSelection };

                    if (isSelectionBlocked || selection.blockedSelectionIds.length > 0) {
                        selection.error = true;
                        selection.message = "This selection cannot be combined.";
                        conflictedEventIds.push(selection.selectionId);
                    }
                }
            });
        }

        if (invalidBets > 0) {
            errorMessage = String.format(resources.BetSlip.SelectionSuspended, invalidBets);
        } else if (conflictedEventIds.length) {
            if (betslipStore.hasNewMultipleSBCalls) {
                warningMessage = resources.BetSlip.SelectionsCannotBeCombined;
            } else {
                errorMessage = resources.BetSlip.SelectionsCannotBeCombined;
            }
        }
        if (priceChangedCount > 0 && !errorMessage) {
            inputBets.draftMode = true;
            //selection from same events
            inputBets.multiples.selections.forEach(function (selection) {
                if (selection.checked) {
                    if (selection.priceFluctuated === -1
                        || selection.priceFluctuated === 1) {
                        selection.error = true;
                    }
                }
            });
            errorMessage = String.format(resources.BetSlip.NoSelectionPriceChange, priceChangedCount);
        }
        inputBets.multiples.error = { message: "" };
        inputBets.multiples.warning = { message: "" };
        if (errorMessage || warningMessage) {
            inputBets.multiples.combinationsForComponent.forEach(function (combinationForComponent) {
                if (!betslipStore.hasNewMultipleSBCalls) {
                    combinationForComponent.disable = true;
                }
            });
            if (errorMessage) {
                inputBets.multiples.error = { message: errorMessage };
            }
            if (warningMessage) {
                inputBets.multiples.warning = { message: warningMessage };
            }
            return false;
        } else { //maxStakeValidationFailed
            let maxStakeValidationFailed = false;
            inputBets.multiples.combinationsForComponent.forEach(function (combinationForComponent) {
                combinationForComponent.error = false;
            });
            inputBets.multiples.combinationsForComponent.forEach(function (combinationForComponent) {
                if (combinationForComponent.stake > 0) {
                    if (combinationForComponent.stake > combinationForComponent.maxStake) {
                        inputBets.multiples.error = {
                            message: String.format(resources.BetSlip.MaxStakeAtPrice, GBEUtils.formatDecimal(combinationForComponent.maxStake, 2, cSymbol, false))
                        };
                        combinationForComponent.error = true;
                        inputBets.activeInputUUID = combinationForComponent.inputStakeUUID;
                        maxStakeValidationFailed = true;
                        return false;
                    } else if (betslipStore.hasNewMultipleSBCalls && combinationForComponent.counterOfferReasonText !== undefined) {
                        inputBets.multiples.error = {
                            message: combinationForComponent.counterOfferReasonText
                        };
                        combinationForComponent.error = true;
                        maxStakeValidationFailed = true;
                    }
                }
            });
            if (maxStakeValidationFailed) {
                return false;
            } else {
                inputBets.multiples.error = null;
                return true;
            }
        }
    }

    cancelBetConfirm() {
        _betslip.mode = "betslip";
        _betConfirm = {};
    }

    /*
     * This is called once a response is there efrom GEC PlaceOrders,
     * Again State for Betslip is prepared here by processing Response from PlaceOrders.
     * State is created with all details to show BetReceipt.
     */

    placedBets(placeOrdersResponse) {
        const resources = this.resources;
        const betslipStore = this;
        const cSymbol = this.getCSymbol();
        let takeOnlyExchange = false;
        if (GBEglobal.settings.genericConfiguration && GBEglobal.settings.genericConfiguration.takeOnlyExchange && GBEglobal.settings.genericConfiguration.takeOnlyExchange.enabled) {
            takeOnlyExchange = true;
        }
        if (_betslip.activeTab === "open-bets") {
            this.processCurrentBetsPLaced(placeOrdersResponse);
        } else {
            //this will clear any IR delay spinnner
            _betslip.singles.delayFactor = 0;
            let error = null;
            if (placeOrdersResponse && placeOrdersResponse.responses) {

                placeOrdersResponse.responses.forEach(function (order, index) {
                    _ordersRequested[index].placedOrder = order;
                });
            } else {
                error = {
                    message: resources.ReturnCodes[placeOrdersResponse.returnCode] || resources.Messages.GeneralIAPIError
                };
                this.clearBetslip();
                _betReceipt = _betslip;
                _betReceipt.mode = "betreceipt";
                _betReceipt.singles.error = error;
                return;
            }

            _polarities.forEach(function (polarity) {
                _betReceipt.singles[polarity].events.forEach(function (event) {
                    event.bets.forEach(function (bet) {
                        _ordersRequested.forEach(function (orderRequested) {
                            if (orderRequested.subscribedSelection.selectionId === bet.selectionId
                                && orderRequested.polarityId === bet.polarityId) {
                                let order = orderRequested.placedOrder;
                                const error = null;
                                let statusClass = "";
                                let status = "";
                                let orderId = null;
                                let message = "";
                                const statusMessage = "";
                                let orderStatusId;
                                let orderBoostMessage = "";
                                const eachWay = bet.isEnabledForEachWayBetting;
                                let inplayOrExpiry;
                                let expiryTimeMessage;
                                let expiresAt;
                                let matchedExeption;
                                let partMatched;
                                let stake = bet.stake;
                                let decimalOdds = bet.odds.decimalOdds;
                                bet.additionalInfo = {
                                    message: ""
                                };
                                if (!order.order || (order.returnCode && order.returnCode > 0) || (takeOnlyExchange && order.order && order.order.matchedStake === 0) || (order.order && order.order.orderStatusId === gec.OrderStatus.Expired && order.order.matchedStake === 0 && order.order.matchedAgainstStake === 0)) { //cancelled
                                    status = "Cancelled";
                                    statusClass = "cancelled";
                                    if ((order.returnCode && resources.ReturnCodes[order.returnCode]) || (order.order === undefined && orderRequested !== undefined)) {
                                        message = resources.ReturnCodes[order.returnCode];
                                        order = orderRequested;
                                    } else {
                                        order = order.order ? order.order : order;
                                    }
                                    if (takeOnlyExchange && order.order && order.order.matchedStake === 0) {
                                        order = order.order;
                                    }
                                    orderId = order && order.orderId ? order.orderId : undefined;
                                    bet.additionalInfo = {
                                        message: "Your bet was cancelled",
                                        class: "danger"
                                    };
                                } else {
                                    order = order.order;
                                    orderStatusId = order.orderStatusId;
                                    //matched?
                                    if (+order.matchedStake === +order.requestedStake) {
                                        status = resources.OrderStatus.Matched;
                                        statusClass = "matched";
                                        stake = order.matchedStake;
                                        if ((order.polarityId === 1 && order.averageMatchedPrice > order.requestedPrice) || (order.polarityId === 2 && order.averageMatchedPrice < order.requestedPrice)) {
                                            const displayRequestedPrice = _oddsLadder.band(order.requestedPrice, order.polarityId * 2 - 1, true).representation;
                                            const displayAverageMatchedPrice = _oddsLadder.band(order.averageMatchedPrice, order.polarityId * 2 - 1, true).representation;
                                            if (displayRequestedPrice !== displayAverageMatchedPrice) {
                                                orderBoostMessage = "This bet got an Odds Boost from " + displayRequestedPrice + " to " + displayAverageMatchedPrice;
                                            }
                                        }
                                    } else {
                                        //unmatched
                                        if (+order.unmatchedStake === +order.requestedStake) {
                                            status = resources.OrderStatus.Unmatched;
                                            statusClass = "un-matched";
                                            stake = eachWay ? stake * 2 : stake;
                                        }
                                        //part match
                                        if (order.matchedStake > 0 && order.unmatchedStake > 0) {
                                            stake = order.matchedStake;
                                            partMatched = " " + GBEUtils.formatDecimal((eachWay ? order.matchedStake / 2 : order.matchedStake), 2, cSymbol, true) + " of " + GBEUtils.formatDecimal((eachWay ? order.requestedStake / 2 : order.requestedStake), 2, cSymbol, true);

                                            if (+bet.orderFillType === 2) {
                                                matchedExeption = true; //@62018 overriding orderstatus jsut to display receipt correct.
                                                statusClass = "part-matched";
                                                orderStatusId = order.orderStatusId;
                                                status = resources.OrderStatus.PartMatched;
                                                bet.additionalInfo = {
                                                    message: "Remaining Stake Cancelled",
                                                    showIcon: true,
                                                    class: "danger"
                                                };
                                                if ((order.polarityId === 1 && order.averageMatchedPrice > order.requestedPrice) || (order.polarityId === 2 && order.averageMatchedPrice < order.requestedPrice)) {
                                                    const displayRequestedPrice = _oddsLadder.band(order.requestedPrice, order.polarityId * 2 - 1, true).representation;
                                                    const displayAverageMatchedPrice = _oddsLadder.band(order.averageMatchedPrice, order.polarityId * 2 - 1, true).representation;
                                                    if (displayRequestedPrice !== displayAverageMatchedPrice) {
                                                        orderBoostMessage = "This bet got an Odds Boost from " + displayRequestedPrice + " to " + displayAverageMatchedPrice;
                                                    }
                                                }
                                            } else {
                                                status = resources.OrderStatus.PartMatched;
                                                statusClass = "part-matched";
                                            }
                                        }
                                        if (!bet.isCurrentlyInRunning && +order.orderFillType === 5) {
                                            message = resources.TakeXSP;
                                        }
                                        if (!bet.isCurrentlyInRunning && !order.cancelOnInRunning) {
                                            message = resources.KeepInPlay;
                                        }
                                        expiresAt = ("" + order.expiresAt).indexOf("7000-12-31");

                                        if (expiresAt !== 0) {
                                            inplayOrExpiry = true;
                                            expiryTimeMessage = "Expiry Time: " + GBEUtils.jsDate(order.expiresAt).formatDate("dd-MM-yyyy HH:mm");
                                        }
                                    }
                                    orderId = order.orderId;

                                    if ((!bet.isCurrentlyInRunning && !order.cancelOnInRunning) || (+order.orderFillType === 5 && order.unmatchedStake > 0)) {
                                        inplayOrExpiry = true;
                                    }
                                }
                                if (order.averageMatchedPrice) {
                                    decimalOdds = order.averageMatchedPrice;
                                    if (+order.polarityId === 1) {
                                        decimalOdds = GBEUtils.truncatePrice(decimalOdds);
                                    }
                                } else {
                                    decimalOdds = order.requestedPrice || order.requestedForSidePrice;
                                }
                                bet.error = error;
                                bet.statusClass = statusClass;
                                bet.status = status;
                                bet.orderId = orderId;
                                bet.isFreeBet = order.isFreeBet;
                                bet.partMatched = partMatched;
                                bet.statusMessage = statusMessage;
                                bet.message = message;
                                bet.expiryTimeMessage = expiryTimeMessage || "";
                                bet.orderBoostMessage = orderBoostMessage;
                                bet.inplayOrExpiry = inplayOrExpiry;
                                bet.expiresAt = expiresAt;
                                //c_Stake & c_StakeOutcome for betreceipt display purpose
                                bet.odds.decimalOdds = decimalOdds;
                                bet.odds.displayOdds = _oddsLadder.band(decimalOdds, 0, true).representation;
                                bet.c_stake = GBEUtils.formatDecimal(eachWay ? stake / 2 : stake, 2, cSymbol);
                                bet.c_stakeOutcome = GBEUtils.formatDecimal(betslipStore.calculateOutcome(bet, decimalOdds, (eachWay ? stake / 2 : stake)), 2, cSymbol);
                                bet.matchedExeption = matchedExeption;
                                bet.orderStatusId = orderStatusId;
                            }
                        });
                    });
                });
            });
            this.processBets({
                inputBets: _betReceipt,
                newSelectionsAdded: false,
                activeSelectionId: null
            });
            this.clearBetslip();
        }
    }

    _processBetConfirm() {
        const cSymbol = this.getCSymbol();
        const resources = this.resources;
        let freeBetChecked = false;
        _betConfirm = {
            "draftMode": false,
            "mode": "betconfirm",
            "activeTab": _betslip.activeTab,
            "activeInputUUID": null,
            "collapsed": false,
            "singles": {
                "expiryChecked": false,
                "CKT": false,
                "displayCKT": false,
                "payOut": _betslip.singles.payOut,
                "displayTakeXSP": false,
                "displayKeep": true,
                "count": 0,
                "back": {
                    "events": []
                },
                "lay": {
                    "events": []
                },
                "totals": {
                    "stake": 0,
                    "outcome": 0
                },
                "delayFactor": 0
            },
            "multiples": {
                "selections": [],
                "combinationsForComponent": [],
                "totals": {
                    "stake": 0,
                    "outcome": 0
                }
            },
            "currentBets": {
                "CKT": false,
                "displayCKT": false,
                "displayTakeXSP": false,
                "displayKeep": true,
                "delayFactor": 0,
                "mode": "betslip",
                "betChange": false,
                "count": 0,
                "unMatchedBets": {
                    "back": {
                        "bets": []
                    },
                    "lay": {
                        "bets": []
                    }
                },
                "matchedBets": {
                    "back": {
                        "bets": []
                    },
                    "lay": {
                        "bets": []
                    }
                },
                "updatedBets": {
                    "back": {
                        "bets": []
                    },
                    "lay": {
                        "bets": []
                    }
                }
            }
        };
        if (_betslip.activeTab === "singles") {
            if (_betslip.singles.displayExpiryTime && _betslip.singles.expiryChecked) {
                _betConfirm.singles.expiryTime = " " + GBEUtils.jsDate(_betslip.singles.expiryTime).formatDate("dd-MM-yyyy HH:mm");
            }
            _betConfirm.singles.expiryChecked = _betslip.singles.expiryChecked;
            _betConfirm.singles.displayExpiryTime = _betslip.singles.displayExpiryTime;
            _betConfirm.singles.CKT = _betslip.singles.CKT;
            _betConfirm.singles.displayCKT = _betslip.singles.displayCKT;
            if (_betslip.singles.freeBetsCheckBox
                && _betslip.singles.freeBetsCheckBox.checked) {
                freeBetChecked = true;
            }

            if (_betConfirm.singles.displayCKT) {
                if (_betConfirm.singles.CKT === 2) {
                    _betConfirm.singles.CKT_message = resources.TakeXSP;//SPIfUnmatched
                } else {
                    if (_betConfirm.singles.CKT === 1) { //keep IR
                        _betConfirm.singles.CKT_message = resources.KeepInPlay;
                    }
                }
            }

            _polarities.forEach(function (polarity) {
                _betslip.singles[polarity].events.forEach(function (event) {
                    const validBetsInEvent = [];
                    event.bets.forEach(function (bet) {
                        if (bet.odds.decimalOdds
                            && bet.stake > 0) {
                            _betConfirm.singles.count += 1;
                            _betConfirm.singles.totals.stake += bet.isEnabledForEachWayBetting ? +bet.stake * 2 : +bet.stake;
                            validBetsInEvent.push({
                                selectionName: bet.selectionName,
                                selectionId: bet.selectionId,
                                polarityId: bet.polarityId,
                                marketName: bet.marketName,
                                isFreeBet: freeBetChecked,
                                odds: {
                                    displayOdds: bet.odds.displayOdds
                                },
                                c_stake: GBEUtils.formatDecimal(bet.stake, 2, cSymbol),
                                c_stakeOutcome: bet.outcome
                            });
                        }
                    });
                    if (validBetsInEvent.length) {
                        _betConfirm.singles[polarity].events.push({
                            "eventClassifierId": event.eventClassifier.eventClassifierId,
                            "eventClassifierName": event.eventClassifier.eventClassifierName,
                            "eventClassifier": event.eventClassifier,
                            "bets": validBetsInEvent
                        });
                    }
                });
            });
            _betConfirm.singles.totals.stake = GBEUtils.formatDecimal(_betConfirm.singles.totals.stake, 2, cSymbol);
        } else if (_betslip.activeTab === "multiples") {
            const selections = _betslip.multiples.selections.filter(function (selection) {
                return selection.checked;
            });
            const freeBetsChecked = _betslip.multiples.freeBetsCheckBox && _betslip.multiples.freeBetsCheckBox.checked;
            _betConfirm.multiples = {};
            _betConfirm.multiples.combinationsForComponent = [];
            _betConfirm.multiples.selections = selections;
            _betConfirm.multiples.totals = _betslip.multiples.totals;

            _betConfirm.activeTab = "multiples";
            let multipleTotalStake = 0;
            let displayCombinationsCount = 0;
            _betslip.multiples.combinationsForComponent.forEach(function (combinationForComponent) {
                if (combinationForComponent.stake > 0) {
                    multipleTotalStake += combinationForComponent.stake * combinationForComponent.count;
                    displayCombinationsCount += 1;
                    _betConfirm.multiples.combinationsForComponent.push({
                        c_stake: GBEUtils.formatDecimal(combinationForComponent.stake, 2, cSymbol, false),
                        c_outcome: GBEUtils.formatDecimal(combinationForComponent.outcome, 2, cSymbol, false),
                        name: combinationForComponent.name,
                        count: combinationForComponent.count,
                        index: combinationForComponent.index,
                        compositeOddsDisplay: combinationForComponent.compositeOddsDisplay,
                        isFreeBet: freeBetsChecked
                    });
                }
            });
            _betConfirm.multiples.displayCombinationsCount = displayCombinationsCount;
            _betConfirm.multiples.totals.stake = GBEUtils.formatDecimal(multipleTotalStake, 2, cSymbol);
        }
    }

    _processFreeBetsEntitlements(freeBetsEntitlements) {
        /*
        @jchacko - 18/05/2017
            get the oldest free bet entitlement for each type of bet.
            1. ExchangeOrders, 2. LocalBets, 3. Multiple bets
            available balance must not be less than minstake requirement of each bet type.
            if an entitlement is enabled for more than one bettype, use it for those bet types.
            expect order of list freebets is in order of its creation.
            So no need of sorting on date in ui
            no validation of event/market type is needed
        */
        const betslipStore = this;
        const freeBetsInfo = {
            "forAnyBetType": false,
            "oldestEntitlementForBetTypes": {
                "exFreeBet": null,
                "FOFreeBet": null,
                "multiplesFreeBet": null
            }
        };
        betslipStore.hasNewMultipleSBCalls = (GBEglobal.settings.multiplesConfiguration && (GBEglobal.settings.multiplesConfiguration.version === 2 || GBEglobal.settings.multiplesConfiguration.version === undefined)) ? true : false;
        if (freeBetsEntitlements) {
            freeBetsEntitlements.forEach(function (entitlement) {
                if (entitlement.status === 1) {
                    if (entitlement.applicableForExchangeOrders
                        && entitlement.amountRemaining >= GBEglobal.settings.minimumStake[GBEglobal.currency]) {
                        freeBetsInfo.oldestEntitlementForBetTypes.exFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.exFreeBet || entitlement;
                    }
                    if (entitlement.applicableForLocalBets
                        && entitlement.amountRemaining >= GBEglobal.settings.minimumStake[GBEglobal.currency]) {
                        freeBetsInfo.oldestEntitlementForBetTypes.FOFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.FOFreeBet || entitlement;
                    }
                    if (entitlement.applicableForMultipleBets && !betslipStore.hasNewMultipleSBCalls
                        && entitlement.amountRemaining >= GBEglobal.settings.multiplesConfiguration[GBEglobal.currency].MinimumTotalStake) {
                        freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet || entitlement;
                    }
                    if (entitlement.applicableForSBMultipleBets && betslipStore.hasNewMultipleSBCalls
                        && entitlement.amountRemaining >= GBEglobal.settings.multiplesConfiguration[GBEglobal.currency].MinimumTotalStake) {
                        freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet || entitlement;
                    }
                    if (freeBetsInfo.oldestEntitlementForBetTypes.exFreeBet
                        && freeBetsInfo.oldestEntitlementForBetTypes.FOFreeBet
                        && freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet) {
                        return false;
                    }
                }
            });


            if (freeBetsInfo.oldestEntitlementForBetTypes.exFreeBet
                || freeBetsInfo.oldestEntitlementForBetTypes.FOFreeBet
                || freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet) {

                freeBetsInfo.forAnyBetType = true;
            }
        }
        betslipStore.freeBetsInfo = freeBetsInfo;
    }

    processCurrentBetsPLaced(placeOrdersResponse) {
        const resources = this.resources;
        const cSymbol = this.getCSymbol();
        const betslipStore = this;
        _betslip.currentBets.mode = "betreceipt";
        _betslip.mode = "betreceipt";
        _betslip.currentBets.betChange = false;
        _betslip.currentBets.delayFactor = 0;
        let error = null;
        if (placeOrdersResponse.changedOrders && placeOrdersResponse.changedOrders.returnCode !== undefined) {
            error = {
                message: resources.ReturnCodes[placeOrdersResponse.changedOrders.returnCode] || resources.Messages.GeneralIAPIError
            };
            placeOrdersResponse.changeRequest.forEach(function (changed) {
                const polarity = (changed.polarityId === 1 || changed.polarity === 1) ? "back" : "lay";
                const order = _betslip.currentBets.unMatchedBets[polarity].bets.find((o) => o.orderId === changed.orderId);
                if (order) {
                    let eventClassifierName = order.eventClassifierFullName();
                    eventClassifierName = eventClassifierName.substr(eventClassifierName.lastIndexOf("~") + 1);
                    eventClassifierName = (eventClassifierName + "").replace("(I\\R)", "");
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifierName = eventClassifierName;
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifierId = order.eventClassifierId ? order.eventClassifierId : order.eventClassifierId();
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifier = null;
                    order.status = "Cancelled ";
                    order.statusClass = "cancelled";
                    order.c_stakeOutcome = order.outcome;
                    order.c_stake = GBEUtils.formatDecimal(order.stake, 2, cSymbol);
                    if (order.cancel !== undefined && !order.cancel) {
                        order.status = "Not Placed ";
                        const errorMessage = resources.ReturnCodes[placeOrdersResponse.changedOrders.returnCode] || resources.Messages.GeneralIAPIError;
                        order.error = {
                            message: errorMessage
                        };
                    }
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].bets.push(order);
                }
            });
            _betReceipt = _betslip;
            _betReceipt.mode = "betreceipt";
            _betReceipt.singles.error = error;
            return;
        }
        if (placeOrdersResponse.changedOrders && placeOrdersResponse.changedOrders.length > 0) {
            placeOrdersResponse.changedOrders.forEach(function (changedOrder) {
                let order = changedOrder.order ? changedOrder.order : changedOrder;
                let eventClassifierName;
                if (changedOrder.order) {
                    order = { ...order, ...changedOrder };
                }
                const changedBet = {};
                let orderBoostMessage = "";
                let expiryTimeMessage = "";
                if (!order || (changedOrder.returnCode && changedOrder.returnCode > 0) || order.orderStatusId === 3) { //cancelled
                    if (changedOrder.returnCode && resources.ReturnCodes[changedOrder.returnCode]) {
                        changedBet.message = resources.ReturnCodes[changedOrder.returnCode];
                    }
                    error = {
                        message: resources.ReturnCodes[placeOrdersResponse.changedOrders.returnCode] || resources.Messages.GeneralIAPIError
                    };
                    eventClassifierName = order.eventClassifierFullName();
                    eventClassifierName = eventClassifierName.substr(eventClassifierName.lastIndexOf("~") + 1);
                    eventClassifierName = (eventClassifierName + "").replace("(I\\R)", "");
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifierName = eventClassifierName;
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifierId = order.eventClassifierId ? order.eventClassifierId : order.eventClassifierId();
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifier = null;
                    changedBet.selectionName = typeof order.selectionName === "function" ? order.selectionName() : order.selectionName;
                    changedBet.marketName = typeof order.marketName === "function" ? order.marketName() : order.marketName;
                    changedBet.polarityId = order.polarityId;
                    changedBet.orderId = order.orderId;
                    changedBet.odds = order.odds;
                    changedBet.status = "Cancelled ";
                    changedBet.statusClass = "cancelled";
                    changedBet.c_stakeOutcome = order.outcome;
                    changedBet.c_stake = GBEUtils.formatDecimal(order.stake, 2, cSymbol);
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].bets.push(changedBet);
                } else {
                    eventClassifierName = order.eventClassifierFullName();
                    eventClassifierName = eventClassifierName.substr(eventClassifierName.lastIndexOf("~") + 1);
                    eventClassifierName = (eventClassifierName + "").replace("(I\\R)", "");
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifierName = eventClassifierName;
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifierId = order.eventClassifierId ? order.eventClassifierId : order.eventClassifierId();
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifier = null;
                    changedBet.selectionName = typeof order.selectionName === "function" ? order.selectionName() : order.selectionName;
                    changedBet.marketName = typeof order.marketName === "function" ? order.marketName() : order.marketName;
                    changedBet.stake = order.stake;
                    changedBet.polarityId = order.polarityId;
                    changedBet.orderId = order.orderId;
                    changedBet.stake = order.stake ? order.stake : order.matchedStake;
                    changedBet.fraction = order.placePayout() || 0;
                    changedBet.isEnabledForEachWayBetting = betslipStore.isEnabledForEW({
                        marketType: order.marketTypeId()
                    });
                    const eachWay = changedBet.isEnabledForEachWayBetting;
                    let inplayOrExpiry = false;
                    if (order.odds) {
                        changedBet.odds = order.odds;
                    } else {
                        changedBet.odds = {
                            "decimalOdds": "",
                            "displayOdds": ""
                        };
                        if (order.averageMatchedPrice && !(order.matchedStake > 0 && order.unmatchedStake > 0)) {
                            changedBet.odds.decimalOdds = order.averageMatchedPrice;
                            if (+order.polarityId === 1) {
                                changedBet.odds.decimalOdds = GBEUtils.truncatePrice(changedBet.odds.decimalOdds);
                            }
                        } else {
                            changedBet.odds.decimalOdds = order.requestedPrice;
                        }
                    }

                    // check odds for back and lay to reound up and down

                    //matched?
                    if (+order.matchedStake === +order.requestedStake) {
                        changedBet.status = resources.OrderStatus.Matched;
                        changedBet.statusClass = "matched";
                        changedBet.stake = order.matchedStake;

                        if ((order.polarityId === 1 && order.averageMatchedPrice > order.requestedPrice)
                            || (order.polarityId === 2 && order.averageMatchedPrice < order.requestedPrice)) {

                            const displayRequestedPrice = _oddsLadder.band(order.requestedPrice, order.polarityId * 2 - 1, true)
                                .representation;
                            const displayAverageMatchedPrice = _oddsLadder.band(order.averageMatchedPrice, order.polarityId * 2 - 1, true)
                                .representation;
                            if (displayRequestedPrice !== displayAverageMatchedPrice) {
                                orderBoostMessage = "This bet got an Odds Boost from " + displayRequestedPrice + " to " + displayAverageMatchedPrice;
                            }
                        }
                    } else {
                        const bet = _betslip.currentBets.unMatchedBets[order.polarityId === 1 ? "back" : "lay"].bets.find((o) => o.orderId === order.orderId);
                        if (eventClassifierName === undefined) {
                            eventClassifierName = bet.eventClassifierFullName();
                            eventClassifierName = eventClassifierName.substr(eventClassifierName.lastIndexOf("~") + 1);
                            eventClassifierName = (eventClassifierName + "").replace("(I\\R)", "");
                            _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifierName = eventClassifierName;
                            _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].eventClassifierId = bet.eventClassifierId;
                        }
                        //unmatched
                        const betStake = eachWay ? bet.stake * 2 : bet.stake;
                        if (+order.unmatchedStake === +betStake || (changedOrder.matchedStake !== undefined && changedOrder.matchedStake === 0)) {
                            changedBet.status = resources.OrderStatus.Unmatched;
                            changedBet.statusClass = "un-matched";
                            changedBet.stake = eachWay ? order.unmatchedStake / 2 : order.unmatchedStake;
                        }
                        //part match
                        if (order.matchedStake > 0 && order.unmatchedStake > 0) {
                            changedBet.stake = order.matchedStake;
                            changedBet.partMatched = " " + GBEUtils.formatDecimal((eachWay ? order.matchedStake / 2 : order.matchedStake), 2, cSymbol, true) + " of " + GBEUtils.formatDecimal((eachWay ? order.requestedStake / 2 : order.requestedStake), 2, cSymbol, true);

                            if (+order.orderFillType === 2) {
                                changedBet.matchedExeption = true; //@62018 overriding orderstatus jsut to display receipt correct.
                                changedBet.statusClass = "matched";
                                changedBet.orderStatusId = 1;
                                changedBet.status = resources.OrderStatus.Matched;
                            } else {
                                changedBet.status = resources.OrderStatus.PartMatched;
                                changedBet.statusClass = "part-matched";
                            }
                            if (order.averageMatchedPrice) {
                                changedBet.odds.decimalOdds = order.averageMatchedPrice;
                                if (+order.polarityId === 1) {
                                    changedBet.odds.decimalOdds = GBEUtils.truncatePrice(changedBet.odds.decimalOdds);
                                }
                            }
                        }
                        if (!order.isCurrentlyInRunning && +order.orderFillType === 5) {
                            changedBet.message = resources.TakeXSP;
                        }
                        if (!order.isCurrentlyInRunning && !order.cancelOnInRunning) {
                            changedBet.message = resources.KeepInPlay;
                        }
                    }
                    const expiresAt = order.expiresAt.indexOf("7000-12-31");
                    if (expiresAt !== 0) {
                        inplayOrExpiry = true;
                        expiryTimeMessage = "Expiry Time: " + GBEUtils.jsDate(order.expiresAt).formatDate("dd-MM-yyyy HH:mm");
                    }
                    if ((!order.isCurrentlyInRunning && !order.cancelOnInRunning) || (+order.orderFillType === 5 && order.unmatchedStake > 0)) {
                        inplayOrExpiry = true;
                    }
                    changedBet.inplayOrExpiry = inplayOrExpiry;
                    changedBet.expiresAt = expiresAt;
                    changedBet.status = changedBet.status + " ";

                    changedBet.orderBoostMessage = orderBoostMessage;
                    changedBet.expiryTimeMessage = expiryTimeMessage;
                    changedBet.odds.displayOdds = _oddsLadder.band(changedBet.odds.decimalOdds, 0, true).representation;
                    changedBet.c_stake = GBEUtils.formatDecimal(changedBet.stake, 2, cSymbol);
                    changedBet.c_stakeOutcome = betslipStore.calculateOutcomeUnMatched(changedBet, changedBet.odds.decimalOdds, changedBet.stake);
                    changedBet.c_stakeOutcome = GBEUtils.formatDecimal(changedBet.c_stakeOutcome, 2, cSymbol);
                    _betslip.currentBets.updatedBets[order.polarityId === 1 ? "back" : "lay"].bets.push(changedBet);
                }
            });
        }
    }

    placedMultipleBets(placeMultipleBetResponse) {
        const error = this.validateMultipleBetsResponse(placeMultipleBetResponse);
        const cSymbol = this.getCSymbol();
        _betReceipt.multiples.error = error;
        if (error && error.message) {
            _betReceipt.multiples.totals.stake = cSymbol + "0.00";
        }
        if (this.hasNewMultipleSBCalls) {
            _betslip.multiples.counterOfferId = null;
        }
        this.clearBetslip();
    }

    updateBetslipPriceFormat() {
        //update all displayodds in singles
        //update all in multiple selections
        //update all in multiple composite odds display
        _polarities.forEach(function (polarity) {
            _betslip.singles[polarity].events.forEach(function (event) {
                event.bets.forEach(function (bet) {
                    const odds = {
                        decimalOdds: "",
                        displayOdds: "",
                        selectedOdds: ""
                    };
                    if (bet.odds.decimalOdds) {
                        odds.decimalOdds = bet.odds.decimalOdds;
                        const band = _oddsLadder.band(odds.decimalOdds, (+bet.polarityId === 1 ? -1 : 1), false, false, true);
                        if (band) {
                            odds.displayOdds = band.representation;
                            odds.decimalOdds = band.price;
                            odds.selectedOdds = band.representation;
                        }
                        bet.odds = odds;
                    }
                });
            });
        });

        _betslip.multiples.combinationsForComponent.forEach(function (combinationForComponent) {
            if (combinationForComponent.compositeOdds) {
                const band = _oddsLadder.band(combinationForComponent.compositeOdds, -1, false, true);
                if (band) {
                    combinationForComponent.compositeOddsDisplay = band.representation;
                }
            }
        });

        _betslip.multiples.combinations.forEach(function (combination) {
            if (combination.compositeOdds) {
                const band = _oddsLadder.getFromRepresentation(combination.compositeOdds, -1, false, true);
                if (band) {
                    combination.compositeOddsDisplay = band.representation;
                }
            }
        });
    }

    validateMultipleBetsResponse(response) {
        const resources = this.resources;
        var error = null;
        var message;
        if (response.returnCode > 0) {
            message = resources.ReturnCodes[response.returnCode];

            switch (response.returnCode) {
                case 1: case 271: case 281: case 406: case 486: case 493: case 494: case 496: case 497: case 498: case 512: case 514: case 555: case 590: case 596: case 599: case 600: case 240:
                    message = resources.CustomMultipleRC[1];
                    break;
                case 2: case 1077: case 1078: case 1079: case 1080:
                    message = resources.CustomMultipleRC[2];
                    break;
                case 17:
                    message = resources.CustomMultipleRC[17];
                    break;
                case 15: case 114: case 131: case 136: case 208: case 293: case 295: case 296:
                    message = resources.CustomMultipleRC[15];
                    break;
                case 302:
                    message = resources.CustomMultipleRC[302];
                    break;
            }
            error = { "message": message };
        }
        return error;
    }

    updateMarket(params) {
        let updateNeeded = false;
        const cSymbol = this.getCSymbol();
        const betslipStore = this;
        if (params && params.market) {
            const market = params.market;
            _polarities.forEach(function (polarity) {
                _betslip.singles[polarity].events.forEach(function (event) {
                    event.bets.forEach(function (bet) {
                        if (+market.marketId === bet.marketId) {
                            if (+market.status !== bet.marketStatus) {
                                //need to update
                                bet.marketStatus = +market.status;
                                updateNeeded = true;
                                GBEglobal.logClientEntry({
                                    componentName: "ex_betslip",
                                    subcomponentName: "MarketStatusChange",
                                    systemInteractionType: 1,
                                    logEntry: market.marketId + "_" + bet.marketStatus
                                });
                            }
                            bet.canBeInRunning = market.canBeInRunning;
                            bet.delayFactor = market.delayFactor;
                            bet.isCurrentlyInRunning = market.isCurrentlyInRunning;
                            bet.c_stake = GBEUtils.formatDecimal(bet.stake, 2, cSymbol);
                            bet.c_stakeOutcome = GBEUtils.formatDecimal(betslipStore.calculateOutcome(bet, bet.odds.decimalOdds, bet.stake, 2, cSymbol));
                        }
                    });
                });

                if (_betslip.activeTab === "open-bets") {
                    _betslip.currentBets.unMatchedBets[polarity].bets.forEach(function (openBet) {
                        if (+market.status !== openBet.marketStatus || market.isCurrentlyInRunning !== openBet.isCurrentlyInRunning) {
                            openBet.marketStatus = +market.status;
                            openBet.canBeInRunning = market.canBeInRunning;
                            openBet.isCurrentlyInRunning = market.isCurrentlyInRunning;
                            updateNeeded = true;
                        }
                    });
                }
            });
        }

        if (updateNeeded) {
            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                inputUUID: null,
                activeSelectionId: null,
                activePolarityId: null,
                autoFocusStake: false
            });
            this.processMultiplesBets({
                inputBets: _betslip,
                inputUUID: null,
                changedIndex: -1,
                changedLegs: []
            });
        }
        return updateNeeded;
    }

    updateSportsBookPrice(params) {
        let priceChangedCount = 0;
        if (params && params.newObject) {
            const selectionId = params.newObject.selectionId;
            const changes = params.changes;
            let displayFixedOdds = "";
            let decimalFixedOdds = "";
            let band;
            if (params.newObject.backReferencePrice) {
                displayFixedOdds = params.newObject.backReferencePrice;
                band = _oddsLadder.getFromRepresentation(displayFixedOdds);
                if (band) {
                    decimalFixedOdds = +(band.price);
                }
            }
            _betslip.multiples.selections.forEach(function (selection) {
                if (+selection.selectionId === +selectionId) {
                    if (!(+selection.decimalFixedOdds === +decimalFixedOdds)) {
                        if (changes) {
                            if (+selection.decimalFixedOdds > +decimalFixedOdds) {
                                selection.priceFluctuated = -1;
                            } else {
                                selection.priceFluctuated = 1;
                            }
                            priceChangedCount += 1;
                            //update priceFluctuated in singles.bets, so it will retain when new price added
                            _polarities.forEach(function (polarity) {
                                const events = _betslip.singles[polarity].events;
                                events.forEach(function (event) {
                                    event.bets.forEach(function (bet) {
                                        if (+bet.selectionId === +selection.selectionId) {
                                            bet.priceFluctuated = selection.priceFluctuated;
                                        }
                                    });
                                });
                            });
                            GBEglobal.logClientEntry({
                                componentName: "ex_betslip",
                                subcomponentName: "SBPriceChange",
                                systemInteractionType: 1,
                                logEntry: selection.selectionId + "_" + decimalFixedOdds
                            });
                        }
                        selection.decimalFixedOdds = decimalFixedOdds;
                        selection.displayFixedOdds = displayFixedOdds;
                    }
                }
            });
        }

        if (priceChangedCount > 0) {
            this.validateMultipleSelectionsAndBets(_betslip);
        }
        return priceChangedCount > 0;
    }

    resetBets() {
        this.clearBetslip();
    }

    closeBetReceipt() {
        if (_betReceipt.activeTab === "singles" &&
            GBEglobal.preferences.confirmationRedirect) { //only made applicable to singles + multiples tab.
            this.clearBetslip();
            _betslip.activeTab = "open-bets";
        }
        if (_betslip.activeTab === "open-bets") {
            this._clearCurrentBets();
            _betslip.currentBets.mode = "betslip";
            _betslip.mode = "betslip";
        } else {
            this.clearBetslip();
        }
    }

    changeBetslipTab(tab) {
        if (_betslip.mode === "betconfirm") {
            return false;
        }
        if (_betslip.mode === "betreceipt" || _betslip.currentBets.mode === "betreceipt") {
            _betslip.mode = "betslip";
            _betslip.currentBets.mode = "betslip";
        }
        _betslip.activeTab = tab;
        return true;
    }

    clickCKT(params) {
        if (_betslip.activeTab === "open-bets") {
            _betslip.currentBets.betChange = true;
            _betslip.currentBets.unMatchedBets[params.openBet.polarityId === 1 ? "back" : "lay"].bets.map((openBet) => {
                if (params.openBet.orderId === openBet.orderId) {
                    openBet.newCKT = params.ckt;
                    _betslip.activeInputUUID = null;
                }
                return openBet;
            });
        } else {
            _betslip.singles.CKT = params.ckt;
        }
    }

    setBack2WinLay2Lose(params) {
        const betslipStore = this;
        if (typeof params.payOut !== "undefined") {
            _betslip.singles.payOut = params.payOut;
        }
        if (typeof params.backToWin !== "undefined") {
            _betslip.singles.backToWin = params.backToWin || 0;
            if (!params.set) {
                return false;
            }
        }
        if (typeof params.layToLose !== "undefined") {
            _betslip.singles.layToLose = params.layToLose || 0;
            if (!params.set) {
                return false;
            }
        }
        //dont set
        _polarities.forEach(function (polarity) {
            _betslip.singles[polarity].events.forEach(function (event) {
                event.bets.forEach(function (bet) {
                    betslipStore.setBack2WinLay2LoseStake(bet);
                });
            });
        });
        this.processBets({
            inputBets: _betslip,
            newSelectionsAdded: false,
            inputUUID: null,
            activeSelectionId: null,
            activePolarityId: null,
            autoFocusStake: false
        });
        return true;
    }

    checkExpiryTime(params) {
        if (_betslip.activeTab === "open-bets") {
            _betslip.currentBets.betChange = true;
            _betslip.currentBets.unMatchedBets.lay.bets.forEach(function (currentLayBet) {
                if (currentLayBet.orderId === params.expiryTimeId) {
                    currentLayBet.expiryChecked = !currentLayBet.expiryChecked;
                }
            });
            _betslip.currentBets.unMatchedBets.back.bets.forEach(function (currentBackBet) {
                if (currentBackBet.orderId === params.expiryTimeId) {
                    currentBackBet.expiryChecked = !currentBackBet.expiryChecked;
                }
            });
        } else {
            const expiryChecked = _betslip.singles.expiryChecked || false;
            _betslip.singles.expiryChecked = !expiryChecked;

            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                inputUUID: null,
                activeSelectionId: null,
                activePolarityId: null,
                autoFocusStake: false
            });
        }
        return true;
    }

    setExpiryTime(params) {
        const expiryTime = params.expiryTime;
        if (_betslip.activeTab === "open-bets") {
            _betslip.currentBets.betChange = true;
            _betslip.currentBets.unMatchedBets.lay.bets.forEach(function (currentBet) {
                if (currentBet.orderId === params.expiryTimeId) {
                    currentBet.expiresAt = expiryTime;
                }
            });
            _betslip.currentBets.unMatchedBets.back.bets.forEach(function (currentBet) {
                if (currentBet.orderId === params.expiryTimeId) {
                    currentBet.expiresAt = expiryTime;
                }
            });
        } else {
            _betslip.singles.expiryTime = expiryTime;

            this.processBets({
                inputBets: _betslip,
                newSelectionsAdded: false,
                inputUUID: null,
                activeSelectionId: null,
                activePolarityId: null,
                autoFocusStake: false,
                expiryTime: expiryTime
            });
        }
        return true;
    }

    setProcessing(processing) {
        _betslip.processing = processing;
    }

    addChangeListener(eventName, callback) {
        this.on(eventName, callback);
    }

    removeChangeListener(eventName, callback) {
        this.removeListener(eventName, callback);
    }

    _calculateOutcomeUnMatched(bet, decimalOdds, stake) {
        let outcome = 0;
        decimalOdds = decimalOdds || bet.odds.decimalOdds;
        stake = stake || bet.stake;

        if (bet.isEnabledForEachWayBetting && bet.fraction > 0) {
            outcome = GBEUtils.calcEachwayWinPrize(stake, bet.fraction, decimalOdds, bet.polarityId);
            if (+bet.polarityId === 2) {
                outcome = outcome * -1;
            }
        } else {
            outcome = GBEUtils.calculatePtnlProfit(decimalOdds, decimalOdds, stake, bet.isEnabledForEachWayBetting);
        }
        return outcome;
    }

    _calculateOutcome(bet, decimalOdds, stake) {
        const payOut = _betslip.singles.payOut;
        let outcome = 0;
        decimalOdds = decimalOdds || bet.odds.decimalOdds;
        stake = stake || bet.stake;

        if (payOut && +bet.polarityId === 2) {
            decimalOdds += 1;
        }
        if (bet.isEnabledForEachWayBetting
            && bet.gecMarket
            && bet.gecMarket.getPlaceFraction) {
            const fraction = bet.gecMarket.getPlaceFraction();
            if (fraction > 0) {
                outcome = GBEUtils.formatDecimal(GBEUtils.calcEachwayWinPrize(stake, fraction, decimalOdds, bet.polarityId), 2, "");
                if (+bet.polarityId === 2) {
                    outcome = outcome * -1;
                }
            }
        } else {
            outcome = GBEUtils.calculatePtnlProfit(decimalOdds, decimalOdds, stake, bet.isEnabledForEachWayBetting);
        }
        return outcome;
    }

    _calculateOutcomeIfPlaced(bet, decimalOdds, stake) {
        let outcome = 0;
        decimalOdds = decimalOdds || bet.odds.decimalOdds;
        stake = stake || bet.stake;
        if (bet.isEnabledForEachWayBetting
            && bet.gecMarket
            && bet.gecMarket.getPlaceFraction) {
            const fraction = bet.gecMarket.getPlaceFraction();
            if (fraction > 0) {
                outcome = GBEUtils.calcEachwayPlacedPrize(stake, fraction, decimalOdds, bet.polarityId);
            }
        }
        return outcome;
    }

    _calculateOutcomeIfUnPlaced(bet, decimalOdds, stake) {
        let outcome = 0;
        decimalOdds = decimalOdds || bet.odds.decimalOdds;
        stake = stake || bet.stake;
        if (bet.isEnabledForEachWayBetting) {
            outcome = GBEUtils.calcEachwayUnPlacedPrize(stake, 0, decimalOdds, bet.polarityId);
        }
        return outcome;
    }

    _calculateOverround(inputBets) {
        if (inputBets.mode === "betslip") {
            let backOverround = 0;
            let layOverround = 0;

            inputBets.singles.backOverround = "0.00";
            inputBets.singles.layOverround = "0.00";

            _polarities.forEach(function (polarity) {
                const events = inputBets.singles[polarity].events;
                events.forEach(function (event) {
                    const bets = event.bets;
                    bets.forEach(function (bet) {
                        if (bet.odds.decimalOdds && +bet.odds.decimalOdds >= 1.01) {
                            if (+bet.polarityId === 1) {
                                backOverround += (1 / bet.odds.decimalOdds);
                            } else {
                                layOverround += (1 / bet.odds.decimalOdds);
                            }
                        }
                    });
                });
            });

            inputBets.singles.backOverround = GBEUtils.formatDecimal(backOverround * 100, 2, "");
            inputBets.singles.layOverround = GBEUtils.formatDecimal(layOverround * 100, 2, "");
        }
    }

    /*
     * this is the main method where State (data) of betslip is updated based on user actions.
     * Like
     * 1. stake or odds is changed,
     * 2. selection removed/ added.
     * 3. Freebets check box clicked.
     * it will recalculate profit/liability, total stake etc
     * There are 3 tabs for betslip. Singles, Multiples & Open Bets.
     * At a time one tab will be set as 'activeTab'
     * There are 3 modes for Betslip tab. betslip, betconfirm & betreceipt.
     *
     * BetslipWrapper will request for new State from this BetslipStore and update the component with that State.
     */

    _processBets(params) {
        //GBEUtils.calculatePtnlProfit()
        //GBEUtils.getCurrencySymbol(GBEglobal.currency)
        //GBEUtils.formatDecimal
        //calculatePtnlProfit: function (selectedOdds, decimalOdds, stake, isEW)
        let invalidBets = 0;
        let displayCKT = false;
        let displayTakeXSP = false;
        let displayKeep = true;
        const resources = this.resources;
        const cSymbol = this.getCSymbol();
        const betslipStore = this;
        const freeBetsInfo = betslipStore.freeBetsInfo;
        let exFreeBet = null;
        let atleastOneValidFreeBetSelection = false;
        let totalStake = 0;
        let totalSingles = 0;
        const uniqueMarketIds = {};
        let singlesAdjustHeightClass = "";
        let takeOnlyExchange = false;
        if (GBEglobal.settings.genericConfiguration
            && GBEglobal.settings.genericConfiguration.takeOnlyExchange
            && GBEglobal.settings.genericConfiguration.takeOnlyExchange.enabled) {
            takeOnlyExchange = true;
        }
        params.inputBets.singles.cSymbol = cSymbol;
        params.inputBets.activeInputUUID = params.inputUUID || null;
        params.inputBets.singles.error = null;
        params.inputBets.singles.displayBackToWin = this.displayBackToWin;
        params.inputBets.singles.displayLayToLose = this.displayLayToLose;
        params.inputBets.singles.displayOverround = this.displayOverround;
        if (params.inputBets.mode === "betslip") {
            if (freeBetsInfo && freeBetsInfo.oldestEntitlementForBetTypes && freeBetsInfo.oldestEntitlementForBetTypes.exFreeBet) {
                exFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.exFreeBet;
            }
        }
        _polarities.forEach(function (polarity) {
            const events = params.inputBets.singles[polarity].events;

            events.forEach(function (event) {
                const bets = event.bets;
                bets.forEach(function (bet) {
                    totalSingles += 1;
                    uniqueMarketIds[bet.marketId] = bet.startTime;
                    let outcome = 0;
                    const decimalOdds = bet.odds.decimalOdds;
                    if (takeOnlyExchange) {
                        bet.oddsReadOnly = true;
                    }
                    if (decimalOdds && +decimalOdds >= 1.01) {
                        if (bet.stake > 0) {
                            if (bet.isEnabledForEachWayBetting) {
                                totalStake += +bet.stake * 2;
                            } else {
                                totalStake += +bet.stake;
                            }
                            outcome = betslipStore.calculateOutcome(bet);
                        }
                    }
                    bet.enableXSP = false;
                    if (GBEglobal.settings.XSPEnabledMarketsData
                        && GBEglobal.settings.XSPEnabledMarketsData[bet.marketId]
                        && GBEglobal.settings.XSPEnabledMarketsData[bet.marketId].enabled) {
                        if (!bet.isCurrentlyInRunning) {
                            displayTakeXSP = true;
                        }
                        bet.enableXSP = true;
                    }

                    if (!bet.isCurrentlyInRunning && bet.canBeInRunning) {
                        displayCKT = true;
                    }

                    if (!bet.canBeInRunning) {
                        displayKeep = false;
                    }

                    if (GBEglobal.preferences.orderFillType && GBEglobal.preferences.orderFillType * 1 === 2) {
                        displayCKT = false;
                    }

                    bet.activeBet = false;
                    bet.autoFocusOdds = false;
                    bet.autoFocusStake = false;
                    if (params.activeSelectionId
                        && bet.selectionId === params.activeSelectionId
                        && bet.polarityId === params.activePolarityId) {
                        bet.activeBet = true;
                    }
                    if (+bet.marketStatus === 2) {
                        bet.inValid = false;
                    } else {
                        //bet.stake = "";
                        bet.inValid = true;
                        invalidBets += 1;
                    }
                    if (exFreeBet) {
                        if (+exFreeBet.eventClassifierId === 1) {
                            if (exFreeBet.marketTypes && exFreeBet.marketTypes.length) {
                                if (exFreeBet.marketTypes.includes(bet.market.marketType)) {
                                    atleastOneValidFreeBetSelection = true;
                                }
                            } else {
                                atleastOneValidFreeBetSelection = true;
                            }
                        } else if (exFreeBet.eventClassifierId > 1) {
                            if (bet.eventClassifierIdAncestryChain.indexOf(exFreeBet.eventClassifierId) > -1) {
                                if (exFreeBet.marketTypes && exFreeBet.marketTypes.length) {
                                    if (exFreeBet.marketTypes.includes(bet.market.marketType)) {
                                        atleastOneValidFreeBetSelection = true;
                                    }
                                } else {
                                    atleastOneValidFreeBetSelection = true;
                                }
                            }
                        }
                    }
                    if (bet.isEnabledForEachWayBetting) {

                        bet.ew = {
                            total: GBEUtils.formatDecimal(0, 2, cSymbol),
                            wins: GBEUtils.formatDecimal(0, 2, cSymbol),
                            placed: GBEUtils.formatDecimal(0, 2, cSymbol),
                            unplaced: GBEUtils.formatDecimal(0, 2, cSymbol),
                            c_wins: GBEUtils.formatDecimal(0, 2, cSymbol),
                            c_placed: GBEUtils.formatDecimal(0, 2, cSymbol),
                            c_unplaced: GBEUtils.formatDecimal(0, 2, cSymbol)
                        };
                        if (bet.stake > 0) {
                            bet.ew.total = GBEUtils.formatDecimal(bet.stake * 2, 2, cSymbol);
                            bet.ew.wins = GBEUtils.formatDecimal(((+bet.polarityId) === 2 ? outcome * -1 : outcome), 2, "");
                            bet.ew.placed = GBEUtils.formatDecimal(betslipStore.calculateOutcomeIfPlaced(bet, decimalOdds, bet.stake), 2, "");
                            bet.ew.unplaced = GBEUtils.formatDecimal(betslipStore.calculateOutcomeIfUnPlaced(bet, decimalOdds, bet.stake), 2, "");

                            bet.ew.c_wins = cSymbol + bet.ew.wins;
                            bet.ew.c_placed = cSymbol + bet.ew.placed;
                            bet.ew.c_unplaced = cSymbol + bet.ew.unplaced;
                        }
                    }

                    bet.outcome = GBEUtils.formatDecimal(outcome, 2, cSymbol);
                });
            });
        });
        if (params.inputBets.singles.freeBetsCheckBox) {
            if (atleastOneValidFreeBetSelection) {
                params.inputBets.singles.freeBetsCheckBox.disabled = false;
                params.inputBets.singles.freeBetsCheckBox.show = true;
            } else {
                params.inputBets.singles.freeBetsCheckBox.disabled = true;
                params.inputBets.singles.freeBetsCheckBox.show = false;
                params.inputBets.singles.freeBetsCheckBox.checked = false;
            }
        }
        if (typeof params.expiryTime === "undefined") {

            let uniqueMarketCount = 0;
            let startTime;
            Object.keys(uniqueMarketIds).forEach(function (value) {
                uniqueMarketCount += 1;
                startTime = uniqueMarketIds[value];
            });
            if (betslipStore.displayExpiryTime && uniqueMarketCount === 1) {
                if (!params.inputBets.singles.displayExpiryTime
                    || !params.inputBets.singles.expiryChecked) {
                    params.inputBets.singles.expiryTime = new Date(startTime);
                    params.inputBets.singles.displayExpiryTime = true;
                    params.inputBets.singles.expiryChecked = false;
                }
            } else {
                params.inputBets.singles.expiryTime = null;
                params.inputBets.singles.displayExpiryTime = false;
                params.inputBets.singles.expiryChecked = false;
            }
        }

        _polarities.forEach(function (polarity) {
            params.inputBets.singles[polarity].events = params.inputBets.singles[polarity].events.filter((ev) => ev.bets.length);
        });
        if (invalidBets > 0) {
            params.inputBets.singles.error = {
                message: String.format(resources.BetSlip.SelectionSuspended, invalidBets)
            };
        }
        if (takeOnlyExchange) {
            displayCKT = false;
        }
        params.inputBets.singles.displayCKT = displayCKT;
        params.inputBets.singles.displayTakeXSP = displayTakeXSP;
        params.inputBets.singles.displayKeep = displayKeep;
        if (displayCKT && !displayTakeXSP && params.inputBets.singles.CKT === 2) {
            params.inputBets.singles.CKT = 0;
        }
        params.inputBets.singles.totals.stake = GBEUtils.formatDecimal(totalStake, 2, cSymbol);
        params.inputBets.multiples.totals.stake = GBEUtils.formatDecimal(0, 2, cSymbol);
        if (params.inputBets.mode === "betreceipt") {
            totalSingles = 0;
        }
        params.inputBets.singles.count = totalSingles;
        betslipStore.calculateOverround(params.inputBets);
        if (params.selectionsAddedOrDeleted) {
            if (totalSingles === 1) {
                //always open singles tab PD-125456
                params.inputBets.activeTab = "singles";
            }
            this.initMultiples(params.inputBets);
        }
        if (params.inputBets.mode === "betslip") {
            if (params.inputBets.singles.displayCKT) {
                singlesAdjustHeightClass = "atTheOff_m";
            }
            if (params.inputBets.singles.displayOverround) {
                singlesAdjustHeightClass += (singlesAdjustHeightClass === "") ? "overround_m" : "-overround_m";
            }
            if (params.inputBets.singles.displayExpiryTime) {
                singlesAdjustHeightClass += (singlesAdjustHeightClass === "") ? "expiry_m" : "-expiry_m";
            }
            if (params.inputBets.singles.freeBetsCheckBox.show) {
                singlesAdjustHeightClass += (singlesAdjustHeightClass === "") ? "freebet_m" : "-freebet_m";
            }
            params.inputBets.singles.singlesAdjustHeightClass = singlesAdjustHeightClass;
        }
    }

    _processMultiplesBets(params) {
        const cSymbol = this.getCSymbol();
        const totals = {
            "outcome": 0,
            "stake": 0
        };
        params.inputBets.activeInputUUID = params.inputUUID || null;
        const combinationsForComponent = params.inputBets.multiples.combinationsForComponent;
        const changedIndex = params.changedIndex;
        const changedLegs = params.changedLegs;

        combinationsForComponent.forEach(function (combinationForComponent) {
            const outcome = "" + GBEUtils.calculatePtnlReturns(combinationForComponent.compositeOdds, combinationForComponent.compositeOdds, combinationForComponent.stake, false);
            combinationForComponent.outcome = "";
            combinationForComponent.c_outcome = "";
            if (!isNaN(outcome)) {
                if ((+combinationForComponent.stake > 0)) {
                    combinationForComponent.outcome = GBEUtils.formatDecimal(outcome, 2, "", false);
                    combinationForComponent.c_outcome = cSymbol + combinationForComponent.outcome;
                    if (changedLegs && changedIndex !== null) {
                        if (changedLegs.length > 1) {
                            if (changedIndex !== combinationForComponent.index) {
                                combinationForComponent.stake = "";
                                combinationForComponent.outcome = "";
                            }
                        } else if (changedLegs.length === 1) {
                            if (combinationForComponent.legs.length > 1) {
                                combinationForComponent.stake = "";
                                combinationForComponent.outcome = "";
                            }
                        }
                    }

                    totals.stake = +totals.stake + (+combinationForComponent.stake * combinationForComponent.count);
                    totals.outcome = +totals.outcome + (+combinationForComponent.outcome);
                } else {
                    combinationForComponent.stake = "";
                    combinationForComponent.outcome = "";
                    combinationForComponent.c_outcome = "";
                }

            }
        });

        if (params.inputBets.mode === "betslip") {
            this.validateMultipleSelectionsAndBets(params.inputBets);
        }

        //check for selections from same market
        totals.stake = GBEUtils.formatDecimal(totals.stake, 2, cSymbol, false);
        params.inputBets.multiples.totals = totals;
    }

    _initMultiples(inputBets) {
        //how many selections are multiples enabled?
        // if in singles tab just reset multiple combinations.
        // if in multiples tab get multiples price quotations if they aren't already requested
        const betslipStore = this;
        let isEnabledForMultipleBets = false;
        const getCombinationForComponent = this.getCombinationForComponent;
        const cSymbol = this.getCSymbol();
        let displayCombinationsCount = 0;
        const multiples = {
            levelsToRequest: [],
            combinations: [],
            combinationsForComponent: [],
            selections: [],
            "totals": {
                "stake": 0,
                "outcome": 0
            },
            "freeBetsCheckBox": {
                "show": false,
                "disabled": false,
                "checked": false
            }
        };
        const freeBetsInfo = this.freeBetsInfo;
        let multiplesFreeBet = null;
        let atleastOneValidFreeBetSelection = false;
        if (inputBets.mode === "betslip") {
            if (freeBetsInfo && freeBetsInfo.oldestEntitlementForBetTypes && freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet) {
                multiplesFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet;
            }
        }
        let checkedSelectionsCount = 0;
        //loop singles back bets.
        let defaultChecked = true;
        inputBets.multiples.error = null;
        const events = inputBets.singles.back.events;
        //sort multiple combinations
        function sortCombinations(a, b) {
            if (a.legs.length === 1) {
                if (a.legs[0] < b.legs[0]) {
                    return -1;
                }
            }
            return 0;
        }
        events.forEach(function (event, index) {
            const bets = event.bets;
            if (!bets.length) {
                events.splice(index, 1);
            }
            bets.forEach(function (bet) {
                isEnabledForMultipleBets = (bet.market.isEnabledForMultipleBets || bet.market.isEnabledForMultiples);
                if (bet.market.isCurrentlyInRunning) {
                    isEnabledForMultipleBets = false;
                }
                if (!isEnabledForMultipleBets) {
                    isEnabledForMultipleBets = GBEglobal.settings.betslipConfiguration && GBEglobal.settings.betslipConfiguration.allowInRunningMultiples;
                }
                if (isEnabledForMultipleBets) {
                    defaultChecked = true;
                    //any selection from same event
                    if (inputBets.multiples && inputBets.multiples.selections && !betslipStore.hasNewMultipleSBCalls) {
                        multiples.selections.forEach(function (selection) {
                            if (selection.eventClassifierId === event.eventClassifierId) {
                                defaultChecked = false;
                            }
                        });
                    }
                    if (defaultChecked && bet.userUnCheckedMultiple || multiples.selections.length >= GBEglobal.settings.multiplesConfiguration.MaxMultipleSelectionsAllowed) {
                        defaultChecked = false;
                    }
                    multiples.selections.push({
                        selectionId: bet.selection.selectionId,
                        selectionName: bet.selectionName,
                        marketId: bet.market.marketId,
                        marketName: bet.marketName,
                        eventClassifierId: event.eventClassifierId,
                        eventClassifierIdAncestryChain: bet.eventClassifierIdAncestryChain,
                        eventClassifierName: event.eventClassifierName,
                        checked: defaultChecked,
                        displayFixedOdds: bet.odds !== undefined && bet.odds.displayOdds ? bet.odds.displayOdds : "",
                        decimalFixedOdds: bet.odds !== undefined && bet.odds.decimalOdds ? bet.odds.decimalOdds : "",
                        priceFluctuated: bet.priceFluctuated,
                        selectionResetCount: bet.selectionResetCount,
                        market: {
                            withdrawalSequenceNumber: bet.market.withdrawalSequenceNumber,
                            marketType: bet.market.marketType
                        }
                    });
                    if (defaultChecked) {
                        checkedSelectionsCount += 1;
                        if (multiplesFreeBet) {
                            if (+multiplesFreeBet.eventClassifierId === 1) {
                                atleastOneValidFreeBetSelection = true;
                            } else if (multiplesFreeBet.eventClassifierId > 1) {
                                if (bet.eventClassifierIdAncestryChain.indexOf(multiplesFreeBet.eventClassifierId) > -1) {
                                    atleastOneValidFreeBetSelection = true;
                                }
                            }

                            if (multiplesFreeBet.marketTypes && multiplesFreeBet.marketTypes.length) {
                                if (multiplesFreeBet.marketTypes.includes(bet.market.marketType)) {
                                    atleastOneValidFreeBetSelection = true;
                                }
                            }
                        }
                    }
                }
            });
        });
        //get basic combinations
        if (checkedSelectionsCount > 1) {
            if (atleastOneValidFreeBetSelection) {
                multiples.freeBetsCheckBox.disabled = false;
                multiples.freeBetsCheckBox.show = true;
            } else {
                multiples.freeBetsCheckBox.disabled = true;
                multiples.freeBetsCheckBox.show = false;
                multiples.freeBetsCheckBox.checked = false;
            }
            if (!betslipStore.hasNewMultipleSBCalls) {
                multiples.combinations = GBEUtils.getMultiplesBaseCombination({
                    includeSeperateSingles: true,
                    accumulatorThreshold: GBEglobal.settings.multiplesConfiguration.accumulatorThreshold,
                    selLen: checkedSelectionsCount
                });

                this.defaultsCombination(multiples.combinations);

                multiples.combinations.forEach(function (combination, index) {
                    const combinationForComponent = getCombinationForComponent(combination, inputBets.multiples.combinations.length, index);
                    multiples.combinationsForComponent.push(combinationForComponent);
                    combination.displayName = multiples.combinationsForComponent[index].displayName;
                    if (!(combinationForComponent.legs.length === 1 && combinationForComponent.legs[0] === 1)) {
                        displayCombinationsCount += 1;
                    }
                });
                multiples.displayCombinationsCount = displayCombinationsCount;
                multiples.combinations = multiples.combinations.sort(sortCombinations);
                multiples.combinationsForComponent = multiples.combinationsForComponent.sort(sortCombinations);
            }
        }

        if (checkedSelectionsCount === 2) {
            multiples.levelsToRequest.push(2);
        } else {
            for (var i = 0; i < checkedSelectionsCount; i += 1) {
                multiples.levelsToRequest.push(i + 1);
            }
        }
        multiples.totals.stake = GBEUtils.formatDecimal(multiples.totals.stake, 2, cSymbol, false);
        inputBets.multiples = multiples;
        this.validateMultipleSelectionsAndBets(inputBets);
    }

    _resetMultiples(inputBets) {
        const betslipStore = this;
        const getCombinationForComponent = this.getCombinationForComponent;
        const cSymbol = this.getCSymbol();
        let checkedSelectionsCount = 0;
        let displayCombinationsCount = 0;
        const multiples = {
            levelsToRequest: [],
            combinations: [],
            combinationsForComponent: [],
            selections: _betslip.multiples.selections,
            "totals": {
                "stake": cSymbol + "0.00",
                "outcome": 0
            },
            "freeBetsCheckBox": {
                "show": false,
                "disabled": false,
                "checked": false
            }
        };
        const freeBetsInfo = this.freeBetsInfo;
        let multiplesFreeBet = null;
        let atleastOneValidFreeBetSelection = false;
        if (inputBets.mode === "betslip") {
            if (freeBetsInfo && freeBetsInfo.oldestEntitlementForBetTypes && freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet) {
                multiplesFreeBet = freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet;
            }
        }
        //sort multiple combinations
        function sortCombinations(a, b) {
            if (a.legs.length === 1) {
                if (a.legs[0] < b.legs[0]) {
                    return -1;
                }
            }
            return 0;
        }
        if (inputBets.mode === "betslip") {
            if (freeBetsInfo && freeBetsInfo.oldestEntitlementForBetTypes && freeBetsInfo.oldestEntitlementForBetTypes.multiplesFreeBet) {
                multiples.freeBetsCheckBox.show = true;
                multiples.freeBetsCheckBox.disabled = false;
            }
        }

        multiples.selections.forEach(function (selection) {
            if (selection.checked) {
                checkedSelectionsCount += 1;
                if (multiplesFreeBet) {
                    if (+multiplesFreeBet.eventClassifierId === 1) {
                        atleastOneValidFreeBetSelection = true;
                    } else if (multiplesFreeBet.eventClassifierId > 1) {
                        if (selection.eventClassifierIdAncestryChain.indexOf(multiplesFreeBet.eventClassifierId) > -1) {
                            atleastOneValidFreeBetSelection = true;
                        }
                    }

                    if (multiplesFreeBet.marketTypes && multiplesFreeBet.marketTypes.length) {
                        if (multiplesFreeBet.marketTypes.includes(selection.market.marketType)) {
                            atleastOneValidFreeBetSelection = true;
                        }
                    }
                }
            }
        });
        //get basic combinations
        if (checkedSelectionsCount > 1) {
            if (atleastOneValidFreeBetSelection) {
                multiples.freeBetsCheckBox.disabled = false;
                multiples.freeBetsCheckBox.show = true;
            } else {
                multiples.freeBetsCheckBox.disabled = true;
                multiples.freeBetsCheckBox.show = false;
                multiples.freeBetsCheckBox.checked = false;
            }
            if (!betslipStore.hasNewMultipleSBCalls) {

                multiples.combinations = GBEUtils.getMultiplesBaseCombination({
                    includeSeperateSingles: true,
                    accumulatorThreshold: GBEglobal.settings.multiplesConfiguration.accumulatorThreshold,
                    selLen: checkedSelectionsCount
                });

                this.defaultsCombination(multiples.combinations);

                multiples.combinations.forEach(function (combination, index) {
                    const combinationForComponent = getCombinationForComponent(combination, multiples.combinations.length, index);
                    multiples.combinationsForComponent.push(combinationForComponent);
                    combination.displayName = multiples.combinationsForComponent[index].displayName;
                    if (!(combinationForComponent.legs.length === 1 && combinationForComponent.legs[0] === 1)) {
                        displayCombinationsCount += 1;
                    }
                });
                multiples.displayCombinationsCount = displayCombinationsCount;
                multiples.combinations = multiples.combinations.sort(sortCombinations);
                multiples.combinationsForComponent = multiples.combinationsForComponent.sort(sortCombinations);
            }
        }

        if (checkedSelectionsCount === 2) {
            multiples.levelsToRequest.push(2);
        } else {
            for (var i = 0; i < checkedSelectionsCount; i += 1) {
                multiples.levelsToRequest.push(i + 1);
            }
        }

        inputBets.multiples = multiples;
    }

    _getCombinationForComponent(combination, totalLength, index) {
        var combinationDisplayName = this.getCombinationDisplayNames(combination, totalLength, index);
        var combinationForComponent = {
            "state": 0,
            "compositeOdds": 0,
            "compositeOddsDisplay": 0,
            "maxStake": 0,
            "count": combination.count,
            "legs": combination.legs,
            "level": combination.level,
            "stake": "",
            "inValid": false,
            "outcome": "",
            "c_outcome": "",
            "notification": { "type": "", "message": "" },
            "disableStake": false,
            "displayName": combinationDisplayName.name,
            "name": combinationDisplayName.name,
            "countName": combinationDisplayName.countName,
            "index": index,
            "inputStakeUUID": GBEUtils.createUUID()
        };
        return combinationForComponent;
    }

    _defaultsCombination(combinations) {
        var combination;
        var j;
        //set defaults for all combinations.
        for (j = 0; j < combinations.length; j += 1) {
            combination = combinations[j];
            combination.state = 0; // 0 = no request made for quotations, 1= request made, 2= request made and quotations successfully updated to the combination
            combination.quotations = [];
            combination.compositeOdds = 0;
            combination.compositeOddsDisplay = 0;
            combination.maxStake = 0;
            combination.stake = 0;
            combination.outcome = "";
            combination.inValid = false;
            combination.errShown = false;
            combination.notification = {
                "type": "",
                "message": ""
            };
        }
    }

    _getCombinationDisplayNames(combination, combinationsLength, index) {
        var resources = this.resources;
        var comNewNames = ["", resources.Singles, resources.Doubles, resources.Trebles, resources.FourFolds, resources.FiveFolds,
            resources.SixFolds, resources.SevenFolds, resources.EightFolds, resources.NineFolds, resources.TenFolds, resources.ElevenFolds,
            resources.TwelveFolds, resources.ThirteenFolds, resources.FourteenFolds, resources.FifteenFolds,
            resources.SixteenFolds, resources.SeventeenFolds, resources.EighteenFolds, resources.NineteenFolds, resources.TwentyFolds];
        var comNewName = ["", resources.Singles, resources.Double, resources.Treble, resources.FourFold, resources.FiveFold,
            resources.SixFold, resources.SevenFold, resources.EightFold, resources.NineFold, resources.TenFold, resources.ElevenFold,
            resources.TwelveFold, resources.ThirteenFold, resources.FourteenFold, resources.FifteenFold,
            resources.SixteenFold, resources.SeventeenFold, resources.EighteenFold, resources.NineteenFold, resources.TwentyFold];

        var returnValue;
        var name = comNewNames[index];
        var countName = "";
        if (combination.legs.length === 1) {

            //is it accumulator
            if (index === 0 && combinationsLength > 1) {
                if (combination.count > 1) {
                    name = String.format(resources.Accumulators, combination.count);
                    countName = String.format(resources.Accumulators, combination.count);
                } else {
                    name = String.format(resources.Accumulator, combination.count);
                    countName = String.format(resources.Accumulator, combination.count);
                }
            } else {
                if (combination.count > 1) {
                    name = String.format(comNewNames[combination.legs[0]], combination.count);
                    countName = String.format(comNewNames[combination.legs[0]], combination.count);
                } else {
                    name = String.format(comNewName[combination.legs[0]], combination.count);
                    countName = String.format(comNewName[combination.legs[0]], combination.count);
                }
            }

            /*if (combination.level === 0) {
                countName = combination.count + " " + resources.Bets;
                name = String.format(combination.name, "").replace(" ()", "");
            } else {
                countName = String.format(combination["0name"], combination.count);
                if (combination.legs && combination.legs[0] && combination.legs[0] === 1) {
                    name = String.format(combination.name, "").replace(" ()", "");
                }
            }*/
        } else { //accumulator

            name = combination.name;
            //if (name.indexOf("Super Yankee") === 0) {
            //    name = "Canadian";
            //}
            name = String.format(name, "").replace(" ()", "");
            name = name + " (" + combination.count + " Bets)";

            countName = name;
        }
        returnValue = {
            name: name,
            countName: countName
        };
        return returnValue;
    }

    _clearCurrentBets() {
        const cSymbol = this.getCSymbol();
        let CKT = 0;
        let takeOnlyExchange = false;
        if (GBEglobal.preferences && +GBEglobal.preferences.defaultCancelKeepTake > -1) {
            CKT = +GBEglobal.preferences.defaultCancelKeepTake;
        }

        if (GBEglobal.settings.genericConfiguration
            && GBEglobal.settings.genericConfiguration.takeOnlyExchange
            && GBEglobal.settings.genericConfiguration.takeOnlyExchange.enabled) {
            takeOnlyExchange = true;
        }
        _betslip.activeTab = "open-bets";
        _betslip.currentBets = {
            "hideUnMatched": takeOnlyExchange,
            "CKT": CKT,
            "displayCKT": false,
            "displayTakeXSP": false,
            "displaykeep": true,
            "displayAverageOdds": false,
            "averageOddsChecked": false,
            "delayFactor": 0,
            "count": 0,
            "betChange": false,
            "mode": "betslip",
            "unMatchedBets": {
                "back": {
                    "bets": []
                },
                "lay": {
                    "bets": []
                }
            },
            "matchedBets": {
                "back": {
                    "bets": []
                },
                "lay": {
                    "bets": []
                }
            },
            "averageOdds": {
                "back": {
                    "bets": []
                },
                "lay": {
                    "bets": []
                }
            },
            "totals": {
                "stake": cSymbol + "0.00",
                "outcome": 0
            },
            "updatedBets": {
                "back": {
                    "bets": []
                },
                "lay": {
                    "bets": []
                }
            }
        };
    }

    processCurrentBets(currentBets) {
        const _this = this;
        const isAverageOddsChecked = _betslip.currentBets.averageOddsChecked;
        _this._clearCurrentBets();
        const cSymbol = this.getCSymbol();
        const displayExpiryTime = _this.displayExpiryTime;
        let displayAverageOdds = false;
        let takeOnlyExchange = false;
        if (GBEglobal.settings.genericConfiguration
            && GBEglobal.settings.genericConfiguration.takeOnlyExchange
            && GBEglobal.settings.genericConfiguration.takeOnlyExchange.enabled) {
            takeOnlyExchange = true;
        }
        _betslip.currentBets.mode = "betslip";
        _betslip.currentBets.hideUnMatched = takeOnlyExchange;
        _betslip.multiples.error = null;
        _betslip.singles.error = null;
        _betslip.currentBets.averageOddsHasBeenChecked = isAverageOddsChecked;
        currentBets.forEach(function (currentBet) {
            const status = currentBet.orderStatusId;
            const matchedStake = currentBet.matchedStake;
            const unMatchedStake = currentBet.unmatchedStake;

            if (status === 1 || status === 2 || status === 3 || status === 6) {
                //active / expired/settled
                if (!takeOnlyExchange && status === 1 && unMatchedStake > 0) {
                    _this.pushCurrentBet(currentBet, "unMatchedBets", cSymbol, displayExpiryTime);
                }
                if (matchedStake > 0) {
                    _this.pushCurrentBet(currentBet, "matchedBets", cSymbol);
                }
            }
        });
        if (_this.displayAverageOdds
            && _betslip.currentBets.matchedBets
            && (_betslip.currentBets.matchedBets.back.bets.length > 1 || _betslip.currentBets.matchedBets.lay.bets.length > 1)) {
            displayAverageOdds = true;
            _this.calculateAverageOdds();
        }
        _betslip.currentBets.displayAverageOdds = displayAverageOdds;
    }

    pushCurrentBet(currentBet, type, cSymbol, displayExpiryTime) {
        let potentialReturn = 0;
        const betslipStore = this;
        let displayKeep = true;
        let displayCKT = false;
        const polarity = currentBet.polarityId === 1 ? "back" : "lay";
        if (!_betslip.currentBets[type][polarity].eventClassifierId) {
            let eventClassifierName = currentBet.eventClassifierFullName();
            eventClassifierName = eventClassifierName.substr(eventClassifierName.lastIndexOf("~") + 1);
            eventClassifierName = (eventClassifierName + "").replace("(I\\R)", "");
            _betslip.currentBets[type][polarity].eventClassifierId = currentBet.eventClassifierId();
            _betslip.currentBets[type][polarity].eventClassifierName = eventClassifierName;
            _betslip.currentBets[type][polarity].eventClassifier = null;
        }
        const newBet = {
            "polarityId": currentBet.polarityId,
            "orderId": currentBet.orderId,
            "priceIndex": null,
            "eventClassifierId": currentBet.eventClassifierId(),
            "eventClassifierFullName": currentBet.eventClassifierFullName,
            "marketId": currentBet.marketId(),
            "marketName": currentBet.marketName(),
            "selectionName": currentBet.selectionName(),
            "selectionId": currentBet.selectionId(),
            "market": null,
            "marketStatus": currentBet.marketStatusId,
            "selection": null,
            "inputOddsUUID": GBEUtils.createUUID(),
            "inputStakeUUID": GBEUtils.createUUID(),
            "inValid": currentBet.isFreeBet,
            "fraction": currentBet.placePayout() || 0,
            "isEnabledForEachWayBetting": betslipStore.isEnabledForEW({
                marketType: currentBet.marketTypeId()
            })
        };

        if (type === "unMatchedBets") {
            let displayTakeXSP = false;
            if (GBEglobal.settings.XSPEnabledMarketsData && GBEglobal.settings.XSPEnabledMarketsData[currentBet.marketId()] && GBEglobal.settings.XSPEnabledMarketsData[currentBet.marketId()].enabled) {
                if (!currentBet.isCurrentlyInRunning || currentBet.orderFillType === 5) {
                    displayTakeXSP = true;
                }
                currentBet.enableXSP = true;
            }
            if (!currentBet.isCurrentlyInRunning && currentBet.willBeInRunning) {
                displayCKT = true;
            }
            let ckt = 0;
            if (currentBet.orderFillType === 5) {
                ckt = 2;
            } else if (!currentBet.cancelOnInRunning) {
                ckt = 1;
            }

            if (!currentBet.willBeInRunning) {
                displayKeep = false;
            }

            if (GBEglobal.preferences.orderFillType && GBEglobal.preferences.orderFillType * 1 === 2) {
                displayCKT = false;
            }

            newBet.stake = currentBet.unmatchedStake;

            if (newBet.isEnabledForEachWayBetting) {
                newBet.stake = newBet.stake / 2;
            }

            potentialReturn = betslipStore.calculateOutcomeUnMatched(newBet, currentBet.requestedPrice, newBet.stake);
            newBet.expectedSelectionResetCount = currentBet.expectedSelectionResetCount;
            newBet.expectedWithdrawalSequenceNumber = currentBet.expectedWithdrawalSequenceNumber;
            newBet.isCurrentlyInRunning = currentBet.isCurrentlyInRunning;
            newBet.canBeInRunning = currentBet.willBeInRunning;
            newBet.orderFillType = currentBet.orderFillType;
            newBet.delayFactor = +currentBet.delayFactor || 0;
            newBet.stakeChanged = false;
            newBet.oddsChanged = false;
            const band = _oddsLadder.band(currentBet.requestedPrice, 0, true);
            if (band.representation.indexOf("<") !== -1) {
                band.representation = band.representation.replace("<", "");
            }
            newBet.odds = {
                "displayOdds": band.representation,
                "decimalOdds": currentBet.requestedPrice,
                "selectedOdds": band.representation
            };
            newBet.originalOdds = {
                "displayOdds": band.representation,
                "decimalOdds": currentBet.requestedPrice,
                "selectedOdds": band.representation
            };
            newBet.cancel = false;
            newBet.betType = "unMatched";
            newBet.displayTakeXSP = displayTakeXSP;
            newBet.displayCKT = displayCKT;
            newBet.displayKeep = displayKeep;
            newBet.CKT = ckt;
            newBet.isFreeBet = currentBet.isFreeBet;
            newBet.expiresAt = new Date(currentBet.startTime);
            newBet.displayExpiryTime = (displayExpiryTime && !currentBet.isFreeBet && !currentBet.isCurrentlyInRunning && currentBet.willBeInRunning);
            newBet.expiryChecked = false;
            newBet.originalStake = GBEUtils.formatDecimal(currentBet.unmatchedStake, 2, "");
            newBet.outcome = GBEUtils.formatDecimal(potentialReturn, 2, cSymbol);
            _betslip.currentBets.count = _betslip.currentBets.count + 1;
            if (currentBet.expiresAt.indexOf("7000-12-31") !== 0) {
                newBet.expiresAt = new Date(currentBet.expiresAt);
                newBet.expiryTimeMessage = "Expiry Time: " + GBEUtils.jsDate(currentBet.expiresAt).formatDate("dd-MM-yyyy HH:mm");
            }
        } else {
            const matchedPrice = currentBet.averageMatchedPrice || currentBet.matchedPrice;

            const stake = currentBet.matchedStake / ([19, 20, 21].includes(currentBet.marketTypeId()) ? 2 : 1);


            potentialReturn = betslipStore.calculateOutcomeUnMatched(newBet, matchedPrice, stake);
            newBet.betType = "matched";
            newBet.statusClass = "matched";
            //const oddsValue = newBet.polarityId === 1 ? Math.floor(matchedPrice * 100) / 100 : Math.ceil(matchedPrice * 100) / 100;
            const band = _oddsLadder.band(matchedPrice, 0, true);
            newBet.odds = {
                "displayOdds": band.representation,
                "decimalOdds": matchedPrice,
                "selectedOdds": band.representation
            };
            newBet.matchedStake = currentBet.matchedStake;
            newBet.c_stake = GBEUtils.formatDecimal(currentBet.matchedStake, 2, cSymbol);
            newBet.c_stakeOutcome = GBEUtils.formatDecimal(potentialReturn, 2, cSymbol);
        }
        _betslip.currentBets[type][polarity].bets.push(newBet);
    }

    _calculateAverageOdds() {
        const cSymbol = this.getCSymbol();
        const averagedBets = {
            back: [],
            lay: []
        };
        let averagedEvent = null;
        let averagedBet;
        const polarities = ["back", "lay"];

        polarities.forEach(function (polarity) {
            if (_betslip.currentBets.matchedBets[polarity].bets.length > 0) {

                averagedEvent = {
                    eventClassifier: null,
                    eventClassifierId: _betslip.currentBets.matchedBets.back.eventClassifierId,
                    eventClassifierName: _betslip.currentBets.matchedBets.back.eventClassifierName,
                    bets: []
                };

                _betslip.currentBets.matchedBets[polarity].bets.forEach(function (bet) {
                    averagedBet = null;
                    averagedBets[polarity].forEach(function (item) {
                        if (item.selectionId === bet.selectionId) {
                            averagedBet = item;
                        }
                    });

                    if (!averagedBet) {
                        averagedBet = {
                            count: 1,
                            error: {
                                message: ""
                            },
                            selectionId: bet.selectionId,
                            selectionName: bet.selectionName,
                            marketName: bet.marketName,
                            stake: bet.matchedStake,
                            odds: {
                                displayOdds: "",
                                decimalOdds: (bet.odds.decimalOdds * bet.matchedStake)
                            }
                        };
                        averagedBets[polarity].push(averagedBet);
                    } else {
                        averagedBet.count += 1;
                        averagedBet.stake += bet.matchedStake;
                        averagedBet.odds.decimalOdds += (bet.odds.decimalOdds * bet.matchedStake);
                    }
                });

                averagedBets[polarity].forEach(function (averagedBet) {
                    let outcome = "";
                    averagedBet.odds.decimalOdds = averagedBet.odds.decimalOdds / averagedBet.stake;
                    const band = _oddsLadder.band(averagedBet.odds.decimalOdds, 0, true);
                    if (band) {
                        averagedBet.odds.displayOdds = band.representation;
                        averagedBet.odds.selectedOdds = band.representation;
                    }

                    averagedBet.c_stake = GBEUtils.formatDecimal(averagedBet.stake, 2, cSymbol);
                    outcome = GBEUtils.calculatePtnlProfit(averagedBet.odds.decimalOdds, averagedBet.odds.decimalOdds, averagedBet.stake, false);
                    averagedBet.c_stakeOutcome = GBEUtils.formatDecimal(outcome, 2, cSymbol);
                    averagedBet.statusClass = "d-none";
                    averagedEvent.bets.push(averagedBet);
                });
                _betslip.currentBets.averageOdds[polarity] = averagedEvent;
            }
        });
        _betslip.currentBets.averageOddsChecked = _betslip.currentBets.averageOddsHasBeenChecked !== undefined ? _betslip.currentBets.averageOddsHasBeenChecked : false;
    }

    calculateMaxLiability(bet) {
        let { outcome } = bet;
        const { stake } = bet;

        outcome = outcome.slice(1, outcome.length);

        if (+outcome > +stake) {
            return (outcome - stake);
        } else {
            return outcome;
        }
    }

    checkAverageOdds() {
        const averageOddsChecked = _betslip.currentBets.averageOddsChecked || false;
        _betslip.currentBets.averageOddsChecked = !averageOddsChecked;
        return true;
    }

    clickCloseNotification() {
        if (_betslip.activeTab === "singles") {
            _betslip.singles.error = null;
        }
        if (_betslip.activeTab === "multiples") {
            _betslip.multiples.error = null;
        }
        return true;
    }

    getCurrentBetsChanged() {
        const currentBetsChanged = [];
        const currentBetsToRemove = [];
        let oddsChanged = false;
        let delayFactor = 0;
        _polarities.forEach(function (polarity) {
            _betslip.currentBets.unMatchedBets[polarity].bets.forEach(function (currentBet) {
                if (currentBet.cancel) {
                    currentBetsToRemove.push(currentBet);
                } else if (currentBet.stakeChanged || currentBet.oddsChanged || (currentBet.newCKT !== undefined && currentBet.newCKT !== currentBet.CKT) || currentBet.expiryChecked) {
                    const deltaAmount = currentBet.isEnabledForEachWayBetting ? ((currentBet.stake * 2) - currentBet.originalStake) : currentBet.stake - currentBet.originalStake;
                    const changedBet = {
                        cancel: false,
                        deltaAmount: GBEUtils.formatDecimal(deltaAmount, 2, "", false), //new price - original price
                        expectedSelectionResetCount: currentBet.expectedSelectionResetCount,
                        expectedWithdrawalSequenceNumber: currentBet.expectedWithdrawalSequenceNumber,
                        orderId: currentBet.orderId,
                        polarity: currentBet.polarityId,
                        requestedForSidePrice: currentBet.odds.decimalOdds, //odss
                        setLatestResetCountAndSeqNumber: !currentBet.isCurrenlyInRunning && currentBet.ckt === 1
                    };
                    if (currentBet.oddsChanged) {
                        oddsChanged = true;
                    }

                    if (currentBet.expiryChecked) {
                        changedBet.expiresAt = currentBet.expiresAt === null ? "7000-12-31" : currentBet.expiresAt;
                    }

                    if (currentBet.isCurrentlyInRunning && currentBet.delayFactor > 0) {
                        delayFactor = currentBet.delayFactor;
                    }

                    if (currentBet.newCKT !== undefined && currentBet.newCKT !== currentBet.CKT) {
                        if (currentBet.newCKT === 2) {
                            changedBet.setToBeSPIfUnmatched = true;
                            changedBet.cancelOnInRunning = true;
                            changedBet.cancelIfSelectionReset = true;
                        } else {
                            changedBet.cancelOnInRunning = (currentBet.newCKT === 1) ? false : true;
                        }
                        if (currentBet.CKT === 2) { //if changing from take XSP, set this to false which will change orderfilltype to 1
                            changedBet.setToBeSPIfUnmatched = false;
                        }
                    }
                    if (typeof changedBet.cancelOnInRunning === "undefined") {
                        if (currentBet.isCurrenlyInRunning) {
                            changedBet.cancelOnInRunning = currentBet.isCurrenlyInRunning;
                        }
                    }

                    if (typeof changedBet.cancelOnInRunning !== "undefined") {
                        if (!currentBet.isCurrenlyInRunning) {
                            if (changedBet.cancelOnInRunning) {
                                changedBet.cancelIfSelectionReset = true;
                            } else {
                                changedBet.cancelIfSelectionReset = false;
                            }
                        }
                    }
                    currentBetsChanged.push(changedBet);
                }
            });
        });

        if (delayFactor > 0) {
            _betslip.currentBets.delayFactor = delayFactor;
        }

        return {
            changeRequest: currentBetsChanged,
            cancelOrder: currentBetsToRemove,
            oddsChanged: oddsChanged
        };
    }

    setVisibleVirtualMarketIds(params) {
        this.visibleVirtualMarketIds = params;
    }
    /*
     * Below are Actions despatched which are processed and  calling appropriate methods in BetslipStore
     * Once BetslipStore method is executed it will emit a change which is listened in BetslipWrapper.
     * 'STORE_CHANGE_BETSLIP' is a common event for any change in Betslip State, others are more specific to the user Actions.
     */

    dispatcherCallback(action) {
        const allowedActionsWhileProcessing = ["SET_BETSLIP_PROCESSING"];
        if (_betslip.processing && !allowedActionsWhileProcessing.includes(action.actionType)) {
            return;
        }
        let placeBetStatus;
        switch (action.actionType) {
            case "SET_DEFAULTS":
                this.setDefaults(action.value);
                break;
            case "UPDATE_ODDSLADDER":
                if (this.updateOddsLadder(action.value)) {
                    this.emitChange("UPDATE_ODDSLADDER");
                }
                this.emitChange("LOADED_ODDSLADDER");
                break;
            case "UPDATE_PREFERENCES":
                this.updatePreferences(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "UPDATE_FREEBETS_ENTITLEMENTS":
                this.silentlyUpdateFreeBetsEntitlements(action.value);
                break;
            case "TOGGLE_BETSLIP":
                this.toggleBetslip(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "EXPAND_BETSLIP":
                if (this.expandBetslip(action.value)) {
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "SELECT_PRICES":
                this.selectPrices(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                this.emitChange("STORE_ADD_REMOVE_PRICES");
                break;
            case "SET_SB_PRICES":
                this.setSportsbookPrices(action.value);
                this.emitChange("STORE_SET_SB_PRICES");
                break;
            case "CLEAR_BETSLIP":
                this.clearBetslip(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                this.emitChange("STORE_ADD_REMOVE_PRICES");
                this.emitChange("STORE_CLEAR_BETSLIP");
                break;
            case "REMOVE_BET":
                if (this.removeBet(action.value)) {
                    this.emitChange("STORE_CHANGE_BETSLIP");
                    this.emitChange("STORE_ADD_REMOVE_PRICES");
                    this.emitChange("STORE_REMOVE_BET");
                } else { // this is from open bets
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "CHANGE_STAKE":
                this.changeStake(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "CHANGE_ODDS":
                this.changeOdds(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "STEP_ODDS":
                this.stepOdds(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "CHECK_FREEBETS":
                this.checkFreeBets(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "VALIDATE_ODDS":
                if (!this.validateOdds(action.value)) {
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "STEP_STAKE":
                this.stepStake(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "SET_MULTIPLE_QUOTATIONS":
                this.setMultipleBetQuotations(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "SET_SB_MULTIPLE_QUOTATIONS":
                this.setSBMultipleBetQuotations(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "CHANGE_MULTI_STAKE":
                this.changeMultiStake(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "STEP_MULTI_STAKE":
                this.stepMultiStake(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "CHANGE_MULTI_OUTCOME":
                this.changeMultiOutcome(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "STEP_MULTI_OUTCOME":
                this.stepMultiOutcome(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "CLICK_MULTI_SELECTION":
                this.clickMultipleSelection(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "PLACE_BETS":
                placeBetStatus = this.placeBets(action.value);
                if (placeBetStatus === 1) {
                    this.emitChange("STORE_PLACE_BETS");
                } else if (placeBetStatus === 2) {
                    this.emitChange("STORE_CONFIRM_BETS");
                } else if (placeBetStatus === 4) {
                    this.emitChange("STORE_MAX_LIABILITY");
                } else {
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "CANCEL_ALL_BETS":
                this.cancelAllBets(action.value);
                this.emitChange("STORE_CANCEL_ALL_BETS");
                break;
            case "CANCEL_BET_CONFIRM":
                this.cancelBetConfirm(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "PLACED_BETS":
                this.placedBets(action.value);
                this.emitChange("STORE_PLACED_BETS");
                this.emitChange("STORE_COMMON_PLACED_BETS");
                break;
            case "PLACED_MULTIPLE_BETS":
                this.placedMultipleBets(action.value);
                this.emitChange("STORE_PLACED_MULTIPLE_BETS");
                this.emitChange("STORE_COMMON_PLACED_BETS");
                break;
            case "PLACED_SPORTSBOOK_BETS":
                this.emitChange("STORE_COMMON_PLACED_BETS");
                break;
            case "RESET_BETS":
                this.resetBets(action.value);
                this.emitChange("STORE_RESET_BETS");
                break;
            case "UPDATE_MARKET":
                if (this.updateMarket(action.value)) { //to avoid too may state updates
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "UPDATE_SPORTSBOOK_PRICE":
                if (this.updateSportsBookPrice(action.value)) { //to avoid too may state updates
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "CLOSE_BETRECEIPT":
                this.closeBetReceipt(action.value);
                this.emitChange("STORE_CLOSE_BETRECEIPT");
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;

            case "CLICK_BETSLIP_TAB":
                if (this.changeBetslipTab(action.value)) {
                    this.emitChange("STORE_CHANGE_BETSLIP_TAB");
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;

            case "CLICK_BETSLIP_CKT":
                this.clickCKT(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "PROCESS_CURRENT_BETS":
                this.processCurrentBets(action.value);
                this.emitChange("CURRENT_BETS_PROCESSED");
                break;
            case "SET_BETSLIP_BACK2WIN_LAY2LOSE":
                if (this.setBack2WinLay2Lose(action.value)) {
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "CHECK_BETSLIP_EXPIRY_TIME":
                if (this.checkExpiryTime(action.value)) {
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "SET_BETSLIP_EXPIRY_TIME":
                if (this.setExpiryTime(action.value)) {
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "CHECK_BETSLIP_AVERAGE_ODDS":
                if (this.checkAverageOdds(action.value)) {
                    this.emitChange("STORE_CHANGE_BETSLIP");
                }
                break;
            case "CLOSE_BETSLIP_NOTIFICATION":
                this.clickCloseNotification();
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "SET_BETSLIP_PROCESSING":
                this.setProcessing(action.value);
                break;
            case "STORE_REMOVE_SB_BET":
            case "STORE_CLEAR_SB_BETS":
            case "CHANGED_SB_BETSLIP":
                this.emitChange("STORE_SB_PRICES_UPDATE");
                break;
            case "SET_ACTIVE_BET_CURSOR":
                this.setActiveBetCursor(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "MULTIPLES_COUNTEROFFER":
                this.multiplesCounterOffer(action.value);
                this.emitChange("STORE_CHANGE_BETSLIP");
                break;
            case "SET_VISIBLE_VIRTUAL_MARKET_IDS":
                this.setVisibleVirtualMarketIds(action.value);
                this.emitChange("STORE_GET_VISIBLE_VIRTUAL_MARKET_IDS");
        }
        return true;
    }
}

export default new BetslipStore();
